
/* ================= Special Order helpers =================== */ 
var SPECIAL_ORDER_MESSAGE = 'This item is a special order — please allow additional lead time of [[lead_time]] for shipment.';
var SPECIAL_ORDER_STATUSES = ['stock', 'nonstock'];

var specialOrder = {
  _leadTimes: null,
  brandKey: function (name) {
    return String(name || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  },
  leadTimeMap: function () {
    if (specialOrder._leadTimes) return specialOrder._leadTimes;
    try {
      var el = document.getElementById('BrandLeadTimes');
      if (el) {
        var raw = JSON.parse(el.textContent) || {};
        var map = {};
        Object.keys(raw).forEach(function (name) {
          var key = specialOrder.brandKey(name);
          if (!(key in map)) map[key] = raw[name]; // first match wins, same as the PDP
        });
        specialOrder._leadTimes = map;
      }
    } catch (e) {
      specialOrder._leadTimes = {};
    }
    return specialOrder._leadTimes || {};
  },
  leadTime: function (hit) {
    var key = specialOrder.brandKey(hit && hit.vendor);
    if (!key) return '';
    var value = specialOrder.leadTimeMap()[key];
    return value ? String(value).trim() : '';
  },
  message: function (hit) {
    var msg = SPECIAL_ORDER_MESSAGE;
    if (msg.indexOf('[[lead_time]]') === -1) return msg;
    var lead = specialOrder.leadTime(hit);
    msg = lead
      ? msg.replace('[[lead_time]]', lead)
      : msg.replace(' of [[lead_time]]', '').replace('[[lead_time]]', '');
    return msg.replace(/\s{2,}/g, ' ').trim();
  },
  meta: function (hit) {
    return (hit && hit.meta && hit.meta.custom) ? hit.meta.custom : {};
  },
  inventory: function (hit) {
    var qty = parseFloat(hit && hit.inventory_quantity);
    return isNaN(qty) ? 0 : qty;
  },
  minQty: function (hit) {
    var min = parseFloat(specialOrder.meta(hit).selling_qty_min);
    return (min && min > 0) ? Math.round(min) : 1;
  },
  // Mirrors the PDP: stock_status is stock/nonstock, variant oversells, variant is orderable
//   isEligible: function (hit) {
//     var status = String(specialOrder.meta(hit).stock_status || '').trim().toLowerCase();
//     var policy = String(hit && hit.inventory_policy || '').trim().toLowerCase();
//     return SPECIAL_ORDER_STATUSES.indexOf(status) !== -1 && policy === 'continue' && hit.can_order !== false;
//   },
  isEligible: function (hit) {
    if (!hit || hit.can_order === false) return false;
    if (String(hit.inventory_policy || '').trim().toLowerCase() !== 'continue') return false;

    var meta = specialOrder.meta(hit);
    if (!('stock_status' in meta)) return true; // not indexed yet — don't block on it

    var status = String(meta.stock_status || '').trim().toLowerCase();
    return SPECIAL_ORDER_STATUSES.indexOf(status) !== -1;
  },
  isSpecialOrder: function (hit, qty) {
    if (!specialOrder.isEligible(hit)) return false;
    var wanted = parseFloat(qty);
    if (!wanted || isNaN(wanted)) wanted = specialOrder.minQty(hit);
    return wanted > specialOrder.inventory(hit);
  }
};

/* ================= Autocomplete hooks =================== */
// Modify default `options`
document.addEventListener('algolia.hooks.initialize', function() {
  algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', function(options) {
    // Modify default options, then return them
    options.placeholder = "Enter keyword, item, model, or part #";
    return options;
  });

   algoliaShopify.hooks.registerHook('beforeRecommendHitTemplate', function(_defaultTemplate, html, item) {
    // console.log("item---", item);
    return html`
    <div
      id="${item.objectID}"
      class="has-form li" role="none"
    >
      <div
        class="ais--hit ais--product product-item-wrapper"
      >
        <div class="ais-hit--image-wrapper">
          <a class="ais-hit--image-wrapper-link" href="/products/${item.handle}">
            <img
              class="ais-hit--picture"
              src="${algoliaShopify.helpers.mediumImage(item)}"
              alt="${item.title} - ${item.variant_title}"
            />
          </a>
          <p class="ais-hit--quickshop link-btn secondary-btn">
            <a class="qsButton overlay-tertiary" href="/products/${item.handle}" data-quickshop="">Quick view</a>
          </p>
          <p><div class="th_wl_col_btn" data-product_id="${item.id}" data-variant_id="${item.objectID}"></div></p>
        </div>

        <div class="ais-hit--details">
          <div class="wrapper">
            ${item.vendor &&
              html`
                <span class="algolia-vendor small"
                  >${item.vendor}</span
                >
              `}
            ${item.sku &&
              html`
                <span class="algolia-sku small">
                  SKU #${item.sku}
                  ${item.meta && item.meta.custom && item.meta.custom.manufacturer_catalog_number &&
                    html`
                      <em>Part #${item.meta.custom.manufacturer_catalog_number}</em>
                    `}
                </span>
              `}
            ${item.inventory_available
              ? html`
                  <p class="stock has-value overlay-valid list-hide"><span class="indicator"></span>${item.inventory_quantity} in stock</p>
                `
              : html`
                  <p class="stock overlay-error list-hide s1tt-cont">Out of stock</p>
                `}
          </div>  
          <p class="ais-hit--title">
            <a
              data-algolia-index="${item.index}"
              data-algolia-position="${item.productPosition}"
              data-algolia-queryid="${item.queryID}"
              data-algolia-objectid="${item.objectID}"
              href="${algoliaShopify.helpers.instantsearchLink(item)}"
              title="${algoliaShopify.helpers.fullTitle(
                item.title,
                item._distinct,
                item.variant_title
              )}"
            >
              ${item.title}
              ${algoliaShopify.helpers.variantTitleAddition(item, item._distinct)}
            </a>
          </p>
          ${item.meta && item.meta.custom && item.meta.custom.short_description &&
          html`
            <div class="info size-12 desktop-only">
              <p>${item.meta.custom.short_description}</p>
            </div>
          `}
          <p
            class="ais-hit--subtitle" style="display: none"
            title="${item.product_type}${algoliaShopify.translation_helpers.by(
              item.vendor
            )}"
          >
            ${item.product_type}
            ${item.vendor &&
              html`
                <span> ${algoliaShopify.translations.by} </span>
              `}
            ${item.vendor}
          </p>
          <p class="price">
            ${algoliaShopify.helpers.displayPrice(item, item._distinct)}
            ${item.meta && item.meta.custom && item.meta.custom.uom &&
            html`
              <em>per ${item.meta.custom.uom}</em>
            `}
            ${item.meta && item.meta.custom && item.meta.custom.selling_qty_increments &&
            html`
              <em> | sold in increments of ${item.meta.custom.selling_qty_increments} ${item.meta.custom.uom}</em>
            `}
          </p>

          ${item.variants_count > 1
          ? html`
          <p class="link-btn">
            <a href="${algoliaShopify.helpers.instantsearchLink(item)}" class="ais-hit--view-product overlay-tertiary" aria-label="View Product" style="margin: 0;">
            <span class="mobile-hide">View Product</span>
            <span class="mobile-only">View</span></a>
          </p>`
          : html` 
            <p>
            <form method="post" action="/cart/add" id="quick-add-template--17739524145377__main-collection${item.objectID}" accept-charset="UTF-8" class="f8pr form-card" enctype="multipart/form-data" novalidate="novalidate">
              <input type="hidden" name="form_type" value="product" style="z-index: 71;" />
              <input type="hidden" name="utf8" value="✓" style="z-index: 70;" />
              <fieldset style="z-index: 69;">
                <input type="hidden" name="id" value="${item.objectID}" style="z-index: 68;" />
                <p class="submit" style="z-index: 67;">
                ${item.inventory_available
                  ? html`
                    
                    <button type="submit" class="ais-hit--atc overlay-tertiary" aria-label="Add to cart" data-vid="${item.objectID}" style="margin: 0;">
                        <span class="mobile-hide">${algoliaShopify.translations.addToCart}</span>
                        <span class="mobile-only">Add</span>
                    </button>`
                  
                  : html`
                  
                    <button
                      class="overlay-tertiary disabled" style="margin: 0;"
                    >
                      ${algoliaShopify.translations.outOfStock}
                    </button>
                `}
                </fieldset>
                <input type="hidden" name="product-id" value="${item.objectID}" style="z-index: 66;" />
                <input type="hidden" name="section-id" value="template--17609068019937__main-collection" style="z-index: 65;" />
                </p>
            </form>
            ${item._distinct && html`<form method="post" action="/cart/add" id="quick-add-template--17739524145377__main-collection${item.objectID}" accept-charset="UTF-8" class="f8pr form-card" enctype="multipart/form-data" novalidate="novalidate">
              <input type="hidden" name="form_type" value="product" style="z-index: 71;" />
              <input type="hidden" name="utf8" value="✓" style="z-index: 70;" />
              <fieldset style="z-index: 69;">
                  <input type="hidden" name="id" value="${item.objectID}" style="z-index: 68;" />
                    <p class="submit" style="z-index: 67;">
                        <!-- <span class="input-amount input-amount-listening"><span class="semantic-amount">
                        <label for="quantity-quick-add-template--17739524145377__main-collection${hit.objectID}" class="hidden">Quantity</label>
                        <a class="incr" role="button" aria-label="Increase by 1"></a><a class="decr disabled" role="button" aria-label="Descrease by 1"></a> 
                        </span></span>-->
                        <span class="input-amounts input-amount-listenings"><span class="semantic-amounts">
                          ${item.meta && item.meta.custom && item.meta.custom.selling_qty_min
                          ? html`
                            <input type="number" class="ais-hit-quantity__input" id="quantity-quick-add-template--17739524145377__main-collection${item.objectID}" name="quantity" value="${item.meta.custom.selling_qty_min}" min="${item.meta.custom.selling_qty_min}" step="${item.meta.custom.selling_qty_increments}" required="" />`
                          : html`
                            <input type="number" class="ais-hit-quantity__input" id="quantity-quick-add-template--17739524145377__main-collection${item.objectID}" name="quantity" value="1" min="1" step="1" required="" />
                          `}
                        </span>
                        </span>
                        
                      ${item.inventory_available
                        ? html`
                          
                          <button type="submit" class="ais-hit--atc overlay-tertiary" aria-label="Add to cart" data-vid="${item.objectID}" style="margin: 0;">
                              <span class="mobile-hide">${algoliaShopify.translations.addToCart}</span>
                              <span class="mobile-only">Add</span>
                          </button>`
                        
                        : html`
                        
                          <button
                            class="overlay-tertiary disabled" style="margin: 0;"
                          >
                            ${algoliaShopify.translations.outOfStock}
                          </button>
                        `}
                      
                    </p>
                </fieldset>
                <input type="hidden" name="product-id" value="${item.objectID}" style="z-index: 66;" />
                <input type="hidden" name="section-id" value="template--17609068019937__main-collection" style="z-index: 65;" />
              </form>
            `}
            </p>
          `}
        </div>
        
      </div>
    </div>
    `;
  })

  algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function(_defaultTemplate, data, html) {
    return html`
      <div class="ais-page">
        <h1 class="ais-h2" style="display: none;">${algoliaShopify.translations.searchTitle}</h1>
        
        <div class="ais-facets-button">
          Show filters
        </div>
        <div class="ais-facets">
          <h6 style="margin-top: 20px;">Search here</h6>
          <div class="ais-input">
            <div class="ais-search-box-container"></div>
            <div class="ais-input-button">
              <div class="ais-clear-input-icon"></div>
            </div>
          </div>
          <div class="ais-clear-refinements-container"></div>
          <div class="ais-current-refined-values-container"></div>


          <!-- ==== Collection List ==== -->
          <div class="ais-facet-dropdown-wrapper show_algolia_filter">
            <input class="ais-dropdown-checkbox" type="checkbox" id="meta.custom.sub-collection-list" name="dropdown" />
            <label for="meta.custom.sub-collection-list" class="ais-range-slider--header ais-facet--header ais-header">By Category</label>
            <div class="ais-facet-meta.custom.sub-collection-list-container ais-facet-dropdown-container">
              <div class="ais-Panel">
                <div class="ais-Panel-body">
                  <div>
                    <div class="ais-RefinementList ais-facet ais-facet-category-list ">
                      <div class="ais-RefinementList-list">
                        <ul class="first-level-menu" data-menu="Fittings & Boxes">
                            <li>
                                <a href="/collections/conduit-fittings-bodies-outlet-boxes-accessories">Fittings & Boxes</a>
                                <ul class="second-level-menu">
                                    <li>
                                        <a href="/collections/bodies-condulets-unilets">Bodies (Condulets-Unilets)
                                        </a>
                                        <ul class="third-level-menu">
                                            <li>
                                                <a href="/collections/aluminum-bodies-cndlt-unlt">Aluminum Bodies (Condulets-Unilets) </a>
                                                <ul class="fourth-level-menu">
                                                    <li>
                                                        <a href="/collections/aluminum-conduit-bodies-covers">Aluminum Conduit Bodies & Covers</a>
                                                    </li>
                                                    <li>
                                                        <a href="/collections/aluminum-fs-fd-type-boxes-covers">Aluminum Fs&Fd Type Boxes & Covers</a>
                                                    </li>
                                                    <li>
                                                        <a href="/collections/aluminum-sealing-bodies">Aluminum Sealing Bodies</a>
                                                    </li>
                                                </ul>
                                            </li>
                                            <li>
                                                <a href="/collections/conduit-bodies-steel">Conduit Bodies - Steel </a>
                                                <ul class="fourth-level-menu">
                                                    <li>
                                                        <a href="/collections/steel-conduit-bodies-covers">Steel Conduit Bodies & Covers</a>
                                                    </li>
                                                    <li>
                                                        <a href="/collections/steel-fs-fd-type-boxes-covers">Steel Fs & Fd Type Boxes & Covers</a>
                                                    </li>
                                                    <li>
                                                        <a href="/collections/steel-sealing-bodies">Steel Sealing Bodies</a>
                                                    </li>
                                                </ul>
                                            </li>
                                            <li>
                                                <a href="/collections/miscellaneous-conduit-bodies">Miscellaneous Conduit Bodies </a>
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        <a href="/collections/cast-boxes">Cast Boxes</a>
                                    </li>
                                    <li>
                                        <a href="/collections/channel-strut-fittings">Channel, Strut & Fittings</a>
                                        <ul class="third-level-menu">
                                            <li>
                                                <a href="/collections/channel-strut">Channel & Strut</a>
                                            </li>
                                            <li>
                                                <a href="/collections/channel-strut-fittings-1">Channel & Strut Fittings</a>
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        <a href="/collections/elbows-cplgs-npls-run-thrd">Elbows-Couplings-Nipples-Run Thread </a>
                                        <ul class="third-level-menu">
                                            <li>
                                                <a href="/collections/emt-elbows">EMT Elbows</a>
                                            </li>
                                            <li>
                                                <a href="/collections/rigid-alum-elbows-couplings-nipples">Rigid Alum Elbows-Couplings-Nipples</a>
                                            </li>
                                            <li>
                                                <a href="/collections/rigid-pvc-coated-aluminum-elbows-couplings-nipples">Rigid PVC Coated Aluminum Elbows-Couplings-Nipples </a>
                                            </li>
                                            <li>
                                                <a href="/collections/rigid-pvc-coated-steel-elbows-couplings-nipples">Rigid PVC Coated Steel Elbows-Couplings-Nipples </a>
                                            </li>
                                            <li>
                                                <a href="/collections/rigid-stainless-steel-elbows-couplings-nipples">Rigid Stainless Steel Elbows-Couplings-Nipples </a>
                                            </li>
                                            <li>
                                                <a href="/collections/rigid-steel-elbows-coupling-nipples-r-thread">Rigid Steel Elbows-Coupling-Nipples-R Thread </a>
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        <a href="/collections/emt-fittings">EMT Fittings </a>
                                        <ul class="third-level-menu">>
                                            <li>
                                                <a href="/collections/emt-combination-fittings">EMT Combination Fittings </a>
                                                <ul class="fourth-level-menu">
                                                    <li>
                                                        <a href="/collections/emt-to-flexible-metallic-conduit-combination-fittings">EMT To Flexible Metallic Conduit Combination Fittings</a>
                                                    </li>
                                                    <li>
                                                        <a href="/collections/emt-to-liquid-tight-flexible-metallic-conduit-combination-fittings">EMT To Liquid Tight Flexible Metallic Conduit Combination Fittings</a>
                                                    </li>
                                                    <li>
                                                        <a href="/collections/emt-to-rigid-combination-fittings">EMT To Rigid Combination Fittings</a>
                                                    </li>
                                                    <li>
                                                        <a href="/collections/die-cast-compression-emt-to-flexible-metallic-conduit-combination-fittings">Die Cast Compression EMT To Flexible Metallic Conduit Combination Fittings</a>
                                                    </li>
                                                    <li>
                                                        <a href="/collections/die-cast-set-screw-emt-to-flexible-metallic-conduit-combination-fittings">Die Cast Set Screw EMT To Flexible Metallic Conduit Combination Fittings</a>
                                                    </li>
                                                    <li>
                                                        <a href="/collections/malleable-compression-emt-to-flexible-metallic-conduit-combination-fittings">Malleable Compression EMT To Flexible Metallic Conduit Combination Fittings</a>
                                                    </li>
                                                    <li>
                                                        <a href="/collections/die-cast-compression-emt-liquid-tight-flex-metallic-conduit-combination-fittings">Die Cast Compression EMT Liquid Tight Flex Metallic Conduit Combination Fittings</a>
                                                    </li>
                                                    <li>
                                                        <a href="/collections/steel-compression-emt-to-liquid-tight-flex-metallic-conduit-combination-fittings">Steel Compression EMT To Liquid Tight Flex Metallic Conduit Combination Fittings</a>
                                                    </li>
                                                    <li>
                                                        <a href="/collections/die-cast-set-screw-emt-to-rigid-combination-fittings">Die Cast Set Screw EMT To Rigid Combination Fittings</a>
                                                    </li>
                                                    <li>
                                                        <a href="/collections/steel-compression-emt-to-rigid-combination-fittings">Steel Compression EMT To Rigid Combination Fittings</a>
                                                    </li>
                                                    <li>
                                                        <a href="/collections/steel-set-screw-emt-to-rigid-combination-fittings">Steel Set Screw EMT To Rigid Combination Fittings</a>
                                                    </li>
                                                </ul>
                                            </li>
                                            <li>
                                                <a href="/collections/emt-conduit-bodies-covers-gaskets">EMT Conduit Bodies, Covers  Gaskets </a>
                                                <ul class="fourth-level-menu">
                                                    <li>
                                                        <a href="/collections/assembled-emt-conduit-bodies">Assembled EMT Conduit Bodies</a>
                                                    </li>
                                                    <li>
                                                        <a href="/collections/emt-conduit-bodies-only">EMT Conduit Bodies Only</a>
                                                    </li>
                                                    <li>
                                                        <a href="/collections/emt-conduit-body-covers-gaskets-only">EMT Conduit Body Covers & Gaskets Only</a>
                                                    </li>
                                                </ul>
                                            </li>
                                            <li>
                                                <a href="/collections/emt-connectors">EMT Connectors </a>
                                                <ul class="fourth-level-menu">
                                                    <li>
                                                        <a href="/collections/die-cast-insulated-compression-emt-connectors">Die Cast Insulated Compression EMT Connectors</a>
                                                    </li>
                                                    <li>
                                                        <a href="/collections/die-cast-insulated-set-screw-emt-connectors">Die Cast Insulated Set Screw EMT Connectors</a>
                                                    </li>
                                                    <li>
                                                        <a href="/collections/die-cast-uninsulated-compression-emt-connectors">Die Cast Uninsulated Compression EMT Connectors</a>
                                                    </li>
                                                    <li>
                                                        <a href="/collections/die-cast-uninsulated-set-screw-emt-connectors">Die Cast Uninsulated Set Screw EMT Connectors</a>
                                                    </li>
                                                    <li>
                                                        <a href="/collections/steel-insulated-compression-emt-connectors">Steel Insulated Compression EMT Connectors</a>
                                                    </li>
                                                    <li>
                                                        <a href="/collections/steel-insulated-set-screw-emt-connectors">Steel Insulated Set Screw EMT Connectors</a>
                                                    </li>
                                                    <li>
                                                        <a href="/collections/steel-uninsulated-compression-emt-connectors">Steel Uninsulated Compression EMT Connectors</a>
                                                    </li>
                                                    <li>
                                                        <a href="/collections/steel-uninsulated-set-screw-emt-connectors">Steel Uninsulated Set Screw EMT Connectors</a>
                                                    </li>
                                                    <li>
                                                        <a href="/collections/die-cast-insulated-straight-compression-emt-connectors">Die Cast Insulated Straight Compression EMT Connectors</a>
                                                    </li>
                                                    <li>
                                                        <a href="/collections/die-cast-insulated-straight-set-screw-emt-connectors">Die Cast Insulated Straight Set Screw EMT Connectors</a>
                                                    </li>
                                                    <li>
                                                        <a href="/collections/die-cast-uninsulated-off-set-90-degree-compression-emt-connectors">Die Cast Uninsulated Off Set / 90 Degree Compression EMT Connectors</a>
                                                    </li>
                                                    <li>
                                                        <a href="/collections/die-cast-uninsulated-straight-compression-emt-connectors">Die Cast Uninsulated Straight Compression EMT Connectors</a>
                                                    </li>
                                                    <li>
                                                        <a href="/collections/die-cast-uninsulated-offset-90-degree-set-screw-emt-connectors">Die Cast Uninsulated Offset / 90 Degree Set Screw EMT Connectors</a>
                                                    </li>
                                                    <li>
                                                        <a href="/collections/die-cast-uninsulated-snap-in-push-on-set-screw-emt-coneectors">Die Cast Uninsulated Snap-In/Push On Set Screw EMT Connectors</a>
                                                    </li>
                                                    <li>
                                                        <a href="/collections/die-cast-uninsulated-straight-set-screw-emt-connectors">Die Cast Uninsulated Straight Set Screw EMT Connectors</a>
                                                    </li>
                                                    <li>
                                                        <a href="/collections/steel-insulated-straight-compression-emt-connectors">Steel Insulated Straight Compression EMT Connectors</a>
                                                    </li>
                                                    <li>
                                                        <a href="/collections/steel-insulated-straight-set-screw-emt-connectors">Steel Insulated Straight Set Screw EMT Connectors</a>
                                                    </li>
                                                    <li>
                                                        <a href="/collections/steel-uninsulated-straight-compression-emt-connectors">Steel Uninsulated Straight Compression EMT Connectors</a>
                                                    </li>
                                                    <li>
                                                        <a href="/collections/steel-uninsulated-straight-set-screw-emt-connectors">Steel Uninsulated Straight Set Screw EMT Connectors</a>
                                                    </li>
                                                </ul>
                                            </li>
                                            <li>
                                                <a href="/collections/emt-couplings">EMT Couplings </a>
                                                <ul class="fourth-level-menu">
                                                    <li>
                                                        <a href="/collections/die-cast-compression-emt-couplings">Die Cast Compression EMT Couplings</a>
                                                    </li>
                                                    <li>
                                                        <a href="/collections/die-cast-set-screw-emt-couplings">Die Cast Set Screw EMT Couplings</a>
                                                    </li>
                                                    <li>
                                                        <a href="/collections/steel-compression-emt-couplings">Steel Compression EMT Couplings</a>
                                                    </li>
                                                    <li>
                                                        <a href="/collections/steel-set-screw-emt-couplings">Steel Set Screw EMT Couplings</a>
                                                    </li>
                                                    <li>
                                                        <a href="/collections/die-cast-straight-set-screw-emt-couplings">Die Cast Straight Set Screw EMT Couplings</a>
                                                    </li>
                                                </ul>
                                            </li>
                                            <li>
                                                <a href="/collections/emt-fitting-tools-accessories">EMT Fitting Tools & Accessories </a>
                                            </li>
                                            <li>
                                                <a href="/collections/emt-insulating-bushings-conduit-caps-spacers">EMT Insulating Bushings, Conduit Caps & Spacers </a>
                                                <ul class="fourth-level-menu">
                                                    <li>
                                                        <a href="/collections/emt-conduit-caps">EMT Conduit Caps</a>
                                                    </li>
                                                    <li>
                                                        <a href="/collections/emt-insulating-bushings">EMT Insulating Bushings</a>
                                                    </li>
                                                </ul>
                                            </li>
                                            <li>
                                                <a href="/collections/emt-pulling-elbows">EMT Pulling Elbows </a>
                                                <ul class="fourth-level-menu">
                                                    <li>
                                                        <a href="/collections/emt-to-box-pulling-elbows">EMT To Box Pulling Elbows</a>
                                                    </li>
                                                    <li>
                                                        <a href="/collections/emt-to-emt-pulling-elbows">EMT To EMT Pulling Elbows</a>
                                                    </li>
                                                </ul>
                                            </li>
                                            <li>
                                                <a href="/collections/emt-straps-clamp-backs">EMT Straps & Clamp Backs </a>
                                                <ul class="fourth-level-menu">
                                                    <li>
                                                        <a href="/collections/malleable-one-hole-emt-straps">Malleable One Hole EMT Straps</a>
                                                    </li>
                                                    <li>
                                                        <a href="/collections/steel-nail-drive-emt-straps">Steel Nail Drive EMT Straps</a>
                                                    </li>
                                                    <li>
                                                        <a href="/collections/steel-one-hole-emt-straps">Steel One Hole EMT Straps</a>
                                                    </li>
                                                    <li>
                                                        <a href="/collections/steel-two-hole-emt-straps">Steel Two Hole EMT Straps</a>
                                                    </li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        <a href="/collections/non-metallic-cable-sec-flex-fittings">Non-Metallic Cable-Sec-Flex Fittings </a>
                                        <ul class="third-level-menu">>
                                            <li>
                                                <a href="/collections/bx-mc-armored-cable-fittings">BX, MC, Armored Cable Fittings </a>
                                            </li>
                                            <li>
                                                <a href="/collections/cable-cord-grips">Cable & Cord Grips </a>
                                            </li>
                                            <li>
                                                <a href="/collections/liquid-tight-flex-conduit-fittings">Liquid Tight Flex. Conduit Fittings</a>
                                            </li>
                                            <li>
                                                <a href="/collections/non-metallic-cable-cable-fittings">Non-Metallic Cable Cable Fittings </a>
                                            </li>
                                            <li>
                                                <a href="/collections/service-entrance-cable-fittings">Service Entrance Cable Fittings </a>
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        <a href="/collections/outlet-boxes-cvrs-bar-hgrs">Outlet Boxes,Covers & Bar Hangers
                                        </a>
                                        <ul class="third-level-menu">>
                                            <li>
                                                <a href="/collections/bar-hangers-outlet-box-accy">Bar Hangers & Outlet Box Accessories </a>
                                            </li>
                                            <li>
                                                <a href="/collections/floor-boxes-accessories">Floor Boxes & Accessories </a>
                                            </li>
                                            <li>
                                                <a href="/collections/outlet-boxes-non-metallic">Outlet Boxes - Non Metallic </a>
                                            </li>
                                            <li>
                                                <a href="/collections/steel-box-pre-fabricate-steel-box-pre-fabricated-assembly">Steel Box Pre-Fabricate Steel Box Pre-Fabricated Assembly </a>
                                            </li>
                                            <li>
                                                <a href="/collections/steel-outlet-boxes">Steel Outlet Boxes & Covers </a>
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        <a href="/collections/rigid-conduit-fittings">Rigid Conduit Fittings </a>
                                        <ul class="third-level-menu">>
                                            <li>
                                                <a href="/collections/plastic-conduit-fittings">Plastic Conduit Fittings </a>
                                            </li>
                                            <li>
                                                <a href="/collections/rigid-aluminum-conduit-fittings">Rigid Aluminum Conduit Fittings </a>
                                            </li>
                                            <li>
                                                <a href="/collections/rigid-pvc-coated-aluminum-conduit-fittings">Rigid PVC Coated Aluminum Conduit Fittings </a>
                                            </li>
                                            <li>
                                                <a href="/collections/rigid-pvc-coated-steel-conduit-fittings">Rigid PVC Coated Steel Conduit Fittings </a>
                                            </li>
                                            <li>
                                                <a href="/collections/rigid-stainless-steel-conduit-fittings">Rigid Stainless Steel Conduit Fittings </a>
                                            </li>
                                            <li>
                                                <a href="/collections/rigid-steel-conduit-fittings">Rigid Steel Conduit Fittings </a>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                        <ul class="first-level-menu" data-menu="Wires, Cords & Cables">
                        <li> <a href="/collections/wires-cords-cables">Wires, Cords & Cables</a>
                          <ul class="second-level-menu">
                              <li>
                                  <a href="/collections/bare-weatherproof-wire">Bare & Weatherproof Wire</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/bare-copper-wire">Bare Copper Wire</a>
                                          <ul class="fourth-level-menu">
                                            <li>
                                              <a href="/collections/copper-wire-bare-soft-drawn-sol">Copper Wire Bare Soft Drawn Solid</a>
                                            </li>
                                            <li>
                                              <a href="/collections/copper-wire-bare-soft-drawn-str">Copper Wire-Bare-Soft Drawn-Str</a>
                                            </li> 
                                          </ul>
                                      </li>
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/building-wire-cable">Building Wire & Cable</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/aluminum-building-wire">Aluminum Building Wire</a>
                                          <ul class="fourth-level-menu">
                                            <li>
                                              <a href="/collections/aluminum-building-wire-thhn-str">Aluminum Building Wire-Thhn-Str</a>
                                            </li>
                                            <li>
                                              <a href="/collections/aluminum-building-wire-xhhw-str">Aluminum Building Wire XHHW Stranded</a>
                                            </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/armored-cable-bx-ac-mc">Armored Cable-BX-AC-MC</a>
                                          <ul class="fourth-level-menu">
                                            <li>
                                              <a href="/collections/alum-armor-cu-condctor-ac90-corflex">Alum Armor Cu Condctor-Ac90-Corflex</a>
                                            </li>
                                            <li>
                                              <a href="/collections/alum-armor-alum-cond-ac90-corflex">Aluminum Armor Aluminum Conductor-Ac90-Corflex</a>
                                            </li>
                                            <li>
                                              <a href="/collections/pvc-ctd-armor-alum-conductors-acwu">PVC-Ctd Armor Alum Conductors-Acwu</a>
                                            </li>
                                            <li>
                                              <a href="/collections/pvc-ctd-armr-cu-cond-acwu-corflex">PVC-Ctd Armr Cu Cond -Acwu-Corflex</a>
                                            </li>
                                            <li>
                                              <a href="/collections/steel-armor-cu-conductors">Steel Armor Cu Conductors</a>
                                            </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/copper-building-wire">Copper Building Wire</a>
                                          <ul class="fourth-level-menu">
                                            <li>
                                              <a href="/collections/copper-building-wire-thhn-t90-sol">Copper Building Wire THHN/T90 Solid</a>
                                            </li>
                                            <li>
                                              <a href="/collections/copper-building-wire-thhn-t90-str">Copper Building Wire THHN/T90 Stranded</a>
                                            </li>
                                            <li>
                                              <a href="/collections/copper-building-wire-xhhw-sol">Copper Building Wire XHHW Solid</a>
                                            </li>
                                            <li>
                                              <a href="/collections/copper-building-wire-xhhw-str">Copper Building Wire XHHW Stranded</a>
                                            </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/non-metallic-cable">Non-Metallic Cable</a>
                                          <ul class="fourth-level-menu">
                                            <li>
                                              <a href="/collections/copper-non-metallic-cable-nm-b-nmd90">Copper Non-Metallic Cable-Nm-B-Nmd90</a>
                                            </li>
                                            <li>
                                              <a href="/collections/copper-non-metallic-cable-uf-nmcb-ug-nmwu">Copper Non-Metallic Cable-UF/NMCB/UG/NMWU</a>
                                            </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/service-entrance-cable">Service Entrance Cable</a>
                                          <ul class="fourth-level-menu">
                                            <li>
                                              <a href="/collections/aluminum-se-cable-ser-ns-1-ns-2">Aluminum Se Cable-Ser / Ns-1 / Ns-2</a>
                                            </li>
                                            <li>
                                              <a href="/collections/aluminum-se-cable-seu">Aluminum Se Cable-Seu</a>
                                            </li>
                                            <li>
                                              <a href="/collections/ser-copper-building-wire">Ser - Copper Building Wire</a>
                                            </li>
                                            <li>
                                              <a href="/collections/seu-copper-building-wire">Seu - Copper Building Wire</a>
                                            </li>
                                            <li>
                                              <a href="/collections/use-rhh-rhw-str-copper-bldg-wire">Use-Rhh-Rhw-Str - Copper Bldg Wire</a>
                                            </li>
                                          </ul>
                                      </li>
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/direct-burial-wire">Direct Burial Wire</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/aluminum-direct-burial-wire-rwu">Aluminum Direct Burial Wire-RWU</a>
                                      </li>
                                  </ul>
                              </li>
                        
                              <li>
                                <a href="/collections/fire-alarm-cables">Fire Alarm Cable</a>
                              </li>
                        
                              <li>
                                  <a href="/collections/high-voltage-power-cable">High-Voltage Power Cable</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/interlocked-armored-cable">Interlocked Armored Cable</a>
                                          <ul class="fourth-level-menu">
                                            <li>
                                              <a href="/collections/alum-intrlckd-alum-armored-cable">Aluminum Interlocked Aluminum Armored Cable</a>
                                            </li>
                                            <li>
                                              <a href="/collections/cu-intrlckd-alum-armored-cable-teck">CU Intrlck Aluminum Armored Cable-Teck</a>
                                            </li>
                                            <li>
                                              <a href="/collections/cu-intrlckd-steel-armred-cable-teck">Cu Intrlckd Steel Armred Cable-Teck</a>
                                            </li>
                                          </ul>
                                      </li>
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/portable-cords-cable">Portable Cords & Cable</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/300v-general-duty-cord-cable">300V General Duty Cord & Cable</a>
                                          <ul class="fourth-level-menu">
                                            <li>
                                              <a href="/collections/sj-sje-300v-cord-cable">Sj-Sje-300V Cord & Cable</a>
                                            </li>
                                            <li>
                                              <a href="/collections/sjow-sjowa-sjoow-300v-cord-cable">Sjow Sjowa Sjoow 300V Cord & Cable</a>
                                            </li>
                                            <li>
                                              <a href="/collections/sjt-sjto-300v-cord-cable">Sjt - Sjto - 300V Cord & Cable</a>
                                            </li>
                                            <li>
                                              <a href="/collections/svt-300v-cord-cable">Svt - 300V Cord & Cable</a>
                                            </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/600v-heavy-duty-cord-cable">600V Heavy Duty Cord & Cable</a>
                                          <ul class="fourth-level-menu">
                                            <li>
                                              <a href="/collections/mtw-awm-tew-tff-600v-hook-up-wire">Mtw Awm Tew Tff - 600V Hook Up Wire</a>
                                            </li>
                                            <li>
                                              <a href="/collections/s-so-600v-cord-cable">S - So - 600V Cord & Cable</a>
                                            </li>
                                            <li>
                                              <a href="/collections/sow-sowa-soow-600v-cord-cable">Sow Sowa Soow 600V Cord & Cable</a>
                                            </li>
                                            <li>
                                              <a href="/collections/sto-stow-stowa-stw-600v-cord-cable">Sto Stow Stowa Stw 600V Cord/Cable</a>
                                            </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/600v-to-2kv-extreme-duty-cable">600V To 2Kv Extreme Duty Cable</a>
                                          <ul class="fourth-level-menu">
                                            <li>
                                              <a href="/collections/welding-cable">Welding Cable</a>
                                            </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/cords-sets">Cords Sets</a>
                                      </li>
                                      <li>
                                          <a href="/collections/lamp-cords">Lamp Cords</a>
                                      </li>
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/service-drop-cable">Service Drop Cable</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/aluminum-service-drop-cable">Aluminum Service Drop Cable</a>
                                      </li>
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/voice-data-video-wire-cable">Voice, Data, Video Wire & Cable</a>
                                  
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/coaxial-cable">Coaxial Cable</a>
                                          <ul class="fourth-level-menu">
                                            <li>
                                              <a href="/collections/non-plenum-coaxial-cable">Non-Plenum Coaxial Cable</a>
                                            </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/multiconductor-cable">Multiconductor Cable</a>
                                          <ul class="fourth-level-menu">
                                            <li>
                                              <a href="/collections/non-plenum-shielded-multicond-cable">Non-Plenum Shielded Multicond Cable</a>
                                            </li>
                                            <li>
                                              <a href="/collections/non-plenum-unshlded-multicond-cable">Non-Plenum Unshlded Multicond Cable</a>
                                            </li>
                                            <li>
                                              <a href="/collections/plenum-shielded-multicond-cable">Plenum Shielded Multicond Cable</a>
                                            </li>
                                            <li>
                                              <a href="/collections/plenum-unshielded-multicond-cable">Plenum Unshielded Multicond Cable</a>
                                            </li>   
                                          </ul>
                                      </li>
                        
                                      <li>
                                          <a href="/collections/multipair-cable">Multipair Cable</a>
                                          <ul class="fourth-level-menu">
                                            <li>
                                              <a href="/collections/plenum-unshielded-multipair-cable">Plenum Unshielded Multipair Cable</a>
                                            </li>
                                          </ul>
                                      </li>
                        
                                      <li>
                                          <a href="/collections/patch-cords-jumpers">Patch Cords & Jumpers</a>
                                      </li>
                        
                                      <li>
                                          <a href="/collections/twisted-pair-cable">Twisted-Pair Cable</a>
                                          <ul class="fourth-level-menu">
                                            <li>
                                              <a href="/collections/non-plenum-unshld-twist-pair-cable">Non-Plenum Unshld Twist-Pair Cable</a>
                                            </li>
                                          </ul>
                                      </li>
                                  </ul>
                              </li>
                          </ul>
                        </li>
                        </ul>

                        <ul class="first-level-menu" data-menu="Accessories & Tools">
                        <li> <a href="/collections/fuses-batteries-signaling-connecting-fastening-tools">Accessories & Tools</a>
                          <ul class="second-level-menu">
                              <li>
                                  <a href="/collections/chimes-doorbell-buttons">Chimes & Doorbell Buttons</a>
                              </li>
                              <li>
                                  <a href="/collections/connecting-materials">Connecting Materials</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/fixture-connectors-wire-nuts-etc">Fixture Connectors (Wire-Nuts,Etc.)</a>
                                      </li>
                                      <li>
                                          <a href="/collections/solderless-connectors">Solderless Connectors</a>
                                          <ul class="fourth-level-menu">
                                            <li>
                                              <a href="/collections/large-terminals-connectors">Large Terminals & Connectors</a>
                                            </li>        
                                            <li>
                                              <a href="/collections/small-terminals-connectors">Small Terminals & Connectors</a>
                                            </li>
                                            <li>
                                              <a href="/collections/splicing-terminating-kits">Splicing & Terminating Kits</a>
                                            </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/tape-markers-soldering-insulating-materials">Tape, Markers, Soldering & Insulating Materials</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/insulating-materials">Insulating Materials</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/markers-marking-tapes">Markers & Marking Tapes</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/soldering-materials">Soldering Materials</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/tape">Tape</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/terminal-blocks-accessories">Terminal Blocks & Accessories</a>
                                      </li>
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/fans">Fans</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/fan-speed-switches-controls">Fan Speed Switches & Controls</a>
                                      </li>
                                      <li>
                                          <a href="/collections/industrial-commercial-fans">Industrial & Commercial Fans</a>
                                      </li>
                                      <li>
                                          <a href="/collections/residential-fans">Residential Fans</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/ceiling-fans-paddle-fans-components">Ceiling Fans (Paddle Fans) & Components</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/exhaust-fans-components">Exhaust Fans & Components</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/portable-residential-fans">Portable Residential Fans</a>
                                              </li>
                                          </ul>
                                      </li>
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/fastening-hardware">Fastening Hardware</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/anchors-fasteners">Anchors & Fasteners</a>
                                      </li>
                                      <li>
                                          <a href="/collections/miscellaneous-fastening-hardware">Miscellaneous Fastening Hardware</a>
                                      </li>
                                      <li>
                                          <a href="/collections/power-guns-studs">Power Guns & Studs</a>
                                      </li>
                                      <li>
                                          <a href="/collections/screws-bolts-staples-wraps-chain">Screws - Bolts - Staples - Wraps - Chain</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/cable-ties-wraps">Cable Ties & Wraps</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/chain-hooks">Chain & Hooks</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/nails-staples-rivets">Nails,Staples,Rivets</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/screws-nuts-bolts-washers">Screws,Nuts,Bolts,Washers</a>
                                              </li>
                                          </ul>
                                      </li>
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/flashlights-batteries">Flashlights & Batteries</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/flashlights-battery-accessories">Flashlights & Battery Accessories</a>
                                      </li>
                                      <li>
                                          <a href="/collections/flashlights-lanterns-warning-lights">Flashlights, Lanterns, Warning Lights</a>
                                      </li>
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/fuses">Fuses</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/accessories-fuseholders-fuseblocks">Accessories - Fuseholders & Fuseblockse</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/clips-reducers-rejectors-etc">Clips,Reducers,Rejectors,Etc.</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/fuseholders-fuseblocks">Fuseholders & Fuseblocks</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/power-blocks-distribution-blocks">Power Blocks & Distribution Blocks</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/distribution-fuses">Distribution Fuses</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/current-limiting-fuses">Current Limiting Fuses</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/dual-element-fuses">Dual Element Fuses</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/plug-fuses-adapters">Plug Fuses & Adapters</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/renewable-non-renewable-fuses">Renewable & Non-Renewable Fuses</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/semicond-rectifier-hi-voltage-fuses">Semicond,Rectifier,Hi-Voltage Fuses</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/small-dimension-fuses">Small Dimension Fuses</a>
                                      </li>
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/motors">Motors</a>
                              </li>
                              <li>
                                  <a href="/collections/signaling-security-equipt">Signaling & Security Equipment</a>
                                  
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/bells-horns-sirens-buzzers-strobes">Bells,Horns,Sirens,Buzzers,Strobes</a>
                                      </li>
                                      <li>
                                          <a href="/collections/fire-detection-alarm-equipment">Fire Detection & Alarm Equipment</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/fire-alarm-pull-stations">Fire & Alarm Pull Stations</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/smoke-heat-detectors">Smoke & Heat Detectors</a>
                                              </li>
                                          </ul>
                                      </li>
                        
                                      <li>
                                          <a href="/collections/misc-signaling-security-equipment">Misc Signaling & Security Equipment</a>
                                      </li>
                        
                                      <li>
                                          <a href="/collections/security-access-equipment">Security & Access Equipment</a>
                                      </li>
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/tools">Tools</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/equipment-benders-pullers-welders">Equipment - Benders, Pullers, Welders</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/equipment-bits-parts-hydraulic-pumps-accy">Equipment Bits, Parts, Hydraulic Pumps & Accessories</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/power-driven-hydraulic-benders">Power Driven & Hydraulic Benders</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/power-driven-hydraulic-pullers">Power Driven & Hydraulic Pullers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/safety-equipment-1">Safety Equipment</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/hand-tools-hydraulic-tools">Hand Tools & Hydraulic Tools</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/benders">Benders</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/cleaners-resurfacers-abrasives">Cleaners,Resurfacers,Abrasives</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/crimpers">Crimpers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/cutters">Cutters</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/fishing-tools">Fishing Tools</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/hand-hydraulic-tool-kits">Hand & Hydraulic Tool Kits</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/hand-tool-bits-parts-accessories">Hand Tool Bits, Parts, Accessories</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/ladders">Ladders</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/miscellaneous-hand-tools">Miscellaneous Hand Tools</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/plrs-wrnch-drvr-saw-pouch-tool-box">Plrs,Wrnch,Drvr,Saw,Pouch,Tool Box</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/pulling-tools">Pulling Tools</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/punch-driver-ko-punches">Punch Driver & Ko Punches</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/strippers">Strippers</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/paint-chemicals-etc">Paint,Chemicals, Etc.</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/adhesives-sealants">Adhesives & Sealants</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/chemicals-cleaners-repair">Chemicals, Cleaners, & Repair</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/lubricant">Lubricant</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/paint">Paint</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/retractable-cable-reels">Retractable Cable Reels</a>
                                      </li>
                                      <li>
                                          <a href="/collections/testers-meters">Testers & Meters</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/cable-locators-accessories">Cable Locators & Accessories</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/fault-finders-accessories">Fault Finders & Accessories</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/meters-panel-instruments-accessories">Meters, Panel Instruments & Accessories</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/testers-accessories">Testers & Accessories</a>
                                              </li>
                                          </ul>
                                      </li>
                                  </ul>
                              </li>
                          </ul>
                        </li>
                        </ul>

                        <ul class="first-level-menu" data-menu="Power Distribution & Enclosures">
                        <li> <a href="/collections/distribution-equipment-enclosures">Power Distribution & Enclosures</a>
                          <ul class="second-level-menu">
                              <li>
                                  <a href="/collections/busway-trolley-underfloor-wall-trench-duct">Busway, Trolley, Underfloor, Wall & Trench Duct</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/busway-fittings-accessories">Busway, Fittings & Accessories</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/busway-accessories">Busway Accessories</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/busway-circuit-breaker-plug-units">Busway Circuit Breaker Plug Units</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/busway-fusible-plug-units">Busway Fusible Plug Units</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/busway-straight-length-sections">Busway Straight Length Sections</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/underfloor-duct-accessories">Underfloor Duct & Accessories</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/underfloor-duct-accessories-1">Underfloor Duct Accessories</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/underfloor-duct-junction-boxes">Underfloor Duct Junction Boxes</a>
                                              </li>
                                          </ul>
                                      </li>
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/circuit-breakers-enclosures-accessories">Circuit Breakers, Enclosures & Accessories</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/circuit-breaker-accessories">Circuit Breaker Accessories</a>
                                      </li>
                                      <li>
                                          <a href="/collections/commercial-circuit-breakers">Commercial Circuit Breakers</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/arc-fault-afci-bolt-on-circuit-breakers">Arc Fault AFCI Bolt-On Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/equipment-protection-epd-bolt-on-circuit-breakers">Equipment Protection EPD Bolt-On Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/ground-fault-gfci-bolt-on-circuit-breakers">Ground Fault GFCI Bolt-On Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/special-application-bolt-on-circuit-breakers">Special Application Bolt-On Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/standard-trip-bolt-on-circuit-breakers">Standard Trip Bolt-On Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/1-pole-arc-fault-afci-bolt-on-circuit-breakers">1 Pole Arc Fault AFCI Bolt-On Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/2-pole-arc-fault-afci-bolt-on-circuit-breakers">2 Pole Arc Fault AFCI Bolt-On Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/1-pole-equipment-protection-epd-bolt-on-circuit-breakers">1 Pole Equipment Protection EPD Bolt-On Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/2-pole-equipment-protection-epd-bolt-on-circuit-breakers">2 Pole Equipment Protection EPD Bolt-On Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/1-pole-ground-fault-gfci-bolt-on-circuit-breakers">1 Pole Ground Fault GFCI Bolt-On Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/2-pole-ground-fault-gfci-bolt-on-circuit-breakers">2 Pole Ground Fault GFCI Bolt-On Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/1-pole-special-application-bolt-on-circuit-breakers">1 Pole Special Application Bolt-On Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/2-pole-special-application-bolt-on-circuit-breakers">2 Pole Special Application Bolt-On Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/3-pole-special-application-bolt-on-circuit-breakers">3 Pole Special Application Bolt-On Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/1-pole-standard-trip-bolt-on-circuit-breakers">1 Pole Standard Trip Bolt-On Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/2-pole-standard-trip-bolt-on-circuit-breakers">2 Pole Standard Trip Bolt-On Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/3-pole-standard-trip-bolt-on-circuit-breakers">3 Pole Standard Trip Bolt-On Circuit Breakers</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                         <a href="/collections/electronic-trip-molded-case-circuit-breakers">Electronic Trip Molded Case Circuit Breakers</a>
                                         <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/interchangeable-trip-electronic-cb-rating-plugs">Interchangeable Trip Electronic Circuit Breaker Rating Plugs</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/interchangeable-trip-electronic-circuit-breakers">Interchangeable Trip Electronic Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/non-interchangeable-trip-electronic-circuit-breakers">Non-Interchangeable Trip Electronic Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/3-pole-interchangeable-trip-electronic-circuit-breakers">3 Pole Interchangeable Trip Electronic Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/3-pole-non-interchangeable-trip-electronic-circuit-breakers">3 Pole Non-Interchangeable Trip Electronic Circuit Breakers</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/enclosed-circuit-breakers-enclosures">Enclosed Circuit Breakers & Enclosures</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/circuit-breaker-enclosures">Circuit Breaker Enclosures</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/enclosed-circuit-breakers">Enclosed Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/1-pole-circuit-breaker-enclosures">1 Pole Circuit Breaker Enclosures</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/2-pole-circuit-breaker-enclosures">2 Pole Circuit Breaker Enclosures</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/3-pole-circuit-breaker-enclosures">3 Pole Circuit Breaker Enclosures</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/enclosed-2-pole-circuit-breakers">Enclosed 2 Pole Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/enclosed-3-pole-circuit-breakers">Enclosed 3 Pole Circuit Breakers</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/industrial-circuit-breakers">Industrial Circuit Breakers</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/base-mount-circuit-breakers">Base Mount Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/din-rail-mount-circuit-breakers">Din Rail Mount Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/unit-mount-circuit-breakers">Unit Mount Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/3-pole-base-mount-circuit-breakers">3 Pole Base Mount Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/1-pole-din-rail-mount-circuit-breakers">1 Pole Din Rail Mount Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/2-pole-din-rail-mount-circuit-breakers">2 Pole Din Rail Mount Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/3-pole-din-rail-mount-circuit-breakers">3 Pole Din Rail Mount Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/1-pole-unit-mount-circuit-breakers">1 Pole Unit Mount Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/2-pole-unit-mount-circuit-breakers">2 Pole Unit Mount Circuit Breakers</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/molded-case-switches">Molded Case Switches</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/bolt-on-molded-case-switches">Bolt-On Molded Case Switches</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/plug-in-molded-case-switches">Plug-In Molded Case Switches</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/3-pole-bolt-on-molded-case-switches">3 Pole Bolt-On Molded Case Switches</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/2-pole-plug-in-molded-case-switches">2 Pole Plug-In Molded Case Switches</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/3-pole-plug-in-molded-case-switches">3 Pole Plug-In Molded Case Switches</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/motor-circuit-supplementary-protector-circuit-breakers">Motor Circuit & Supplementary Protector Circuit Breakers</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/motor-circuit-protector-circuit-breakers">Motor Circuit Protector Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/supplementary-protector-circuit-breakers">Supplementary Protector Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/2-pole-motor-circuit-protector-circuit-breakers">2 Pole Motor Circuit Protector Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/3-pole-motor-circuit-protector-circuit-breakers">3 Pole Motor Circuit Protector Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/1-pole-supplementary-protector-circuit-breakers">1 Pole Supplementary Protector Circuit Breakers</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/plug-in-circuit-breakers">Plug-In Circuit Breakers</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/arc-fault-afci-plug-in-circuit-breakers">Arc Fault AFCI Plug-In Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/equipment-protection-epd-plug-in-circuit-breakers">Equipment Protection EPD Plug-In Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/ground-fault-gfci-plug-in-circuit-breakers">Ground Fault GFCI Plug-In Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/special-application-plug-in-circuit-breakers">Special Application Plug-In Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/standard-trip-plug-in-circuit-breakers">Standard Trip Plug-In Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/1-pole-arc-fault-afci-plug-in-circuit-breakers">1 Pole Arc Fault AFCI Plug-In Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/2-pole-arc-fault-afci-plug-in-circuit-breakers">2 Pole Arc Fault AFCI Plug-In Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/1-pole-equipment-protection-epd-plug-in-circuit-breakers">1 Pole Equipment Protection EPD Plug-In Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/2-pole-equipment-protection-epd-plug-in-circuit-breakers">2 Pole Equipment Protection EPD Plug-In Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/1-pole-ground-fault-gfci-plug-in-circuit-breakers">1 Pole Ground Fault GFCI Plug-In Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/2-pole-ground-fault-gfci-plug-in-circuit-breakers">2 Pole Ground Fault GFCI Plug-In Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/1-pole-special-application-plug-in-circuit-breakers">1 Pole Special Application Plug-In Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/2-pole-special-application-plug-in-circuit-breakers">2 Pole Special Application Plug-In Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/1-pole-standard-trip-plug-in-circuit-breakers">1 Pole Standard Trip Plug-In Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/2-pole-standard-trip-plug-in-circuit-breakers">2 Pole Standard Trip Plug-In Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/3-pole-standard-trip-plug-in-circuit-breakers">3 Pole Standard Trip Plug-In Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/duplex-standard-trip-plug-in-circuit-breakers">Duplex Standard Trip Plug-In Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/quadplex-standard-trip-plug-in-circuit-breakers">Quadplex Standard Trip Plug-In Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/tandem-standard-trip-plug-in-circuit-breakers">Tandem Standard Trip Plug-In Circuit Breakers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/triplex-standard-trip-plug-in-circuit-breakers">Triplex Standard Trip Plug-In Circuit Breakers</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/thermal-magnetic-trip-molded-case-circuit-breakers">Thermal Magnetic Trip Molded Case Circuit Breakers</a>
                                      </li>
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/enclosures-wireway-trough">Enclosures, Wireway & Trough</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/enclosure-climate-environmental-controls">Enclosure Climate & Environmental Controls</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/enclosure-air-conditioners">Enclosure Air Conditioners</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/enclosure-drain-pressure-breathers">Enclosure Drain & Pressure Breathers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/enclosure-humidity-temperature-controls">Enclosure Humidity & Temperature Controls</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/enclosure-cabinet-wireway-general-accessories">Enclosure, Cabinet & Wireway General Accessories</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/cabinet-general-accessories">Cabinet General Accessories</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/enclosure-general-accessories">Enclosure General Accessories</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/wireway-general-accessories">Wireway General Accessories</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/metallic-enclosures-boxes-cabinets">Metallic Enclosures, Boxes, Cabinets</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/nema-type-1-metallic-enclosures-boxes-cabinets">NEMA Type 1 Metallic Enclosures, Boxes, Cabinets</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/nema-type-12-metallic-enclosures-boxes-cabinets">NEMA Type 12 Metallic Enclosures, Boxes, Cabinets</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/nema-type-4-metallic-enclosures-boxes-cabinets">NEMA Type 4 Metallic Enclosures, Boxes, Cabinets</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/nema-type-4x-metallic-enclosures-boxes-cabinets">NEMA Type 4X Metallic Enclosures, Boxes, Cabinets</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/nema-type-9-metallic-enclosures-boxes-cabinets">NEMA Type 9 Metallic Enclosures, Boxes, Cabinets</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/nema-types-12-13-metallic-enclosures-boxes-cabinets">NEMA Types 12 & 13 Metallic Enclosures, Boxes, Cabinets</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/nema-types-3-3r-metallic-enclosures-boxes-cabinets">NEMA Types 3 & 3R Metallic Enclosures, Boxes, Cabinets</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/nema-types-4-12-metallic-enclosures-boxes-cabinets">NEMA Types 4 & 12 Metallic Enclosures, Boxes, Cabinets</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/nema-types-4-4x-metallic-enclosures-boxes-cabinets">NEMA Types 4 & 4X Metallic Enclosures, Boxes, Cabinets</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/non-metallic-enclosures-boxes-cabinets">Non-Metallic Enclosures, Boxes, Cabinets</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/nema-types-4-4x-12-13-non-metallic-enclosures-boxes-cabinets">NEMA Types 4, 4X, 12 & 13 Non-Metallic Enclosures, Boxes & Cabinets</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/telephone-cabinets-fuse-cabinets-meter-boxes">Telephone Cabinets, Fuse Cabinets, Meter Boxes</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/meter-boxes">Meter Boxes</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/telephone-cabinets">Telephone Cabinets</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/underground-boxes-vaults-accessories">Underground Boxes, Vaults & Accessories</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/underground-boxes">Underground Boxes</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/wireway-trough-gutter">Wireway, Trough & Gutter</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/nema-type-1-trough-gutter">NEMA Type 1 Trough & Gutter</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/nema-type-1-wireway-fittings">NEMA Type 1 Wireway & Fittings</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/nema-type-12-trough-gutter">NEMA Type 12 Trough & Gutter</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/nema-type-12-wireway-fittings">NEMA Type 12 Wireway & Fittings</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/nema-type-3r-trough-gutter">NEMA Type 3R Trough & Gutter</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/nema-type-4x-wireway-fittings">NEMA Type 4X Wireway & Fittings</a>
                                              </li>
                                          </ul>
                                      </li>
                                  </ul>
                              </li>
                              <li>
                                 <a href="/collections/ground-rods-grounding-systems">Ground Rods & Grounding Systems</a>
                              </li>
                              <li>
                                  <a href="/collections/load-centers-ser-entr-eqpt">Load Centers & Service Entrance Equipment</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/fusible-load-centers">Fusible Load Centers</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/power-outlet-panel-pedestal-accessories">Power Outlet Panel & Pedestal Accessories</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/unmetered-power-outlet-panels">Unmetered Power Outlet Panels</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/unmetered-power-outlet-pedestals">Unmetered Power Outlet Pedestals</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/load-centers-accessories">Load Centers & Accessories</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/load-center-accessories">Load Center Accessories</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/load-center-covers">Load Center Covers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/single-phase-convertible-load-centers">Single Phase Convertible Load Centers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/single-phase-main-breaker-load-centers">Single Phase Main Breaker Load Centers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/single-phase-main-lug-load-centers">Single Phase Main Lug Load Centers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/three-phase-convertible-load-centers">Three Phase Convertible Load Centers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/three-phase-main-breaker-load-centers">Three Phase Main Breaker Load Centers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/three-phase-main-lug-load-centers">Three Phase Main Lug Load Centers</a>
                                              </li>
                                          </ul>
                                      </li>
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/meter-sockets-mounting-assemblies">Meter Sockets & Mounting Assemblies</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/current-transformer-metering">Current Transformer Metering</a>
                                      </li>
                                      <li>
                                          <a href="/collections/ganged-meter-sockets">Ganged Meter Sockets</a>
                                      </li>
                                      <li>
                                          <a href="/collections/meter-mains">Meter Mains</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/commercial-meter-mains">Commercial Meter Mains</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/residential-meter-mains">Residential Meter Mains</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/meter-socket-metering-accessories">Meter Socket & Metering Accessories</a>
                                      </li>
                                      <li>
                                          <a href="/collections/meter-socket-circuit-breaker-combinations">Meter Socket Circuit Breaker Combinations</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/residential-meter-socket-circuit-breaker-combinations">Residential Meter Socket Circuit Breaker Combinations</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/modular-group-metering">Modular & Group Metering</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/commercial-meter-modules">Commercial Meter Modules</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/main-circuit-breaker-modules">Main Circuit Breaker Modules</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/main-fusible-switch-modules">Main Fusible Switch Modules</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/main-lug-terminal-box-modules">Main Lug Terminal Box Modules</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/main-pull-box-modules">Main Pull Box Modules</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/residential-meter-modules">Residential Meter Modules</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/multiple-meter-banks-centers-packs">Multiple Meter Banks, Centers & Packs</a>
                                      </li>
                                      <li>
                                          <a href="/collections/single-meter-sockets">Single Meter Sockets</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/commercial-single-meter-sockets">Commercial Single Meter Sockets</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/residential-single-meter-sockets">Residential Single Meter Sockets</a>
                                              </li>
                                          </ul>
                                      </li>
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/panelboards-switchboards">Panelboards & Switchboards</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/panelboards-switchboards" class="toggle">Toggle submenu Panelboards & Switchboards</a>
                                      </li>
                                      <li>
                                          <a href="/collections/lighting-panelboards">Lighting Panelboards</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/lighting-panelboard-accessories">Lighting Panelboard Accessories</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/lighting-panelboard-boxes">Lighting Panelboard Boxes</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/lighting-panelboard-fronts-trims">Lighting Panelboard Fronts & Trims</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/single-phase-assembled-plug-in-lighting-panelboards">Single Phase Assembled Plug-In Lighting Panelboards</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/power-distribution-panelboards">Power Distribution Panelboards</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/main-breaker-power-distribution-panelboard-interiors">Main Breaker Power Distribution Panelboard Interiors</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/main-lug-power-distribution-panelboard-interiors">Main Lug Power Distribution Panelboard Interiors</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/power-distribution-panelboard-accessories">Power Distribution Panelboard Accessories</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/power-distribution-panelboard-boxes">Power Distribution Panelboard Boxes</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/power-distribution-panelboard-fronts-trims">Power Distribution Panelboard Fronts & Trims</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/three-phase-main-breaker-power-distribution-panelboard-interiors">Three Phase Main Breaker Power Distribution Panelboard Interiors</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/single-phase-main-lug-power-distribution-panelboard-interiors">Single Phase Main Lug Power Distribution Panelboard Interiors</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/three-phase-main-lug-power-distribution-panelboard-interiors">Three Phase Main Lug Power Distribution Panelboard Interiors</a>
                                              </li>
                                          </ul>
                                      </li>                        
                                      <li>
                                          <a href="/collections/switchboards">Switchboards</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/switchboard-switchgear-accessories">Switchboard & Switchgear Accessories</a>
                                              </li>
                                          </ul>
                                      </li>
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/pwr-transfrmrs-conditioning">Power Transformers & Conditioning</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/control-transformers">Control Transformers</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/core-coil-industrial-control-transformers">Core & Coil Industrial Control Transformers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/encapsulated-industrial-control-transformers">Encapsulated Industrial Control Transformers</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/current-transformers">Current Transformers</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/general-purpose-current-transformers">General Purpose Current Transformers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/split-core-current-transformers">Split Core Current Transformers</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/distribution-transformers">Distribution Transformers</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/buck-boost-dry-type-transformers-600v-or-less">Buck & Boost Dry Type Transformers 600V Or Less</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/electrostatically-shielded-dry-type-transformers-600v-or-less">Electrostatically Shielded Dry Type Transformers 600V Or Less</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/energy-efficient-dry-type-transformers-600v-or-less">Energy Efficient Dry Type Transformers 600V Or Less</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/general-purpose-dry-type-transformers-600v-or-less">General Purpose Dry Type Transformers 600V Or Less</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/k-rated-non-linear-load-dry-type-transformers-600v-or-less">K Rated Non Linear Load Dry Type Transformers 600V Or Less</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/low-temperature-rise-dry-type-transformers-600v-or-less">Low Temperature Rise Dry Type Transformers 600V Or Less</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/non-ventilated-totally-enclosed-dry-type-transformers-600v-or-less">Non Ventilated Totally Enclosed Dry Type Transformers 600V Or Less</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/three-phase-electrostatically-shielded-dry-type-transformers-600v-or-less">Three Phase Electrostatically Shielded Dry Type Transformers 600V Or Less</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/three-phase-energy-efficient-dry-type-transformers-600v-or-less">Three Phase Energy Efficient Dry Type Transformers 600V Or Less</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/single-phase-general-purpose-dry-type-transformers-600v-or-less">Single Phase General Purpose Dry Type Transformers 600V Or Less</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/three-phase-general-purpose-dry-type-transformers-600v-or-less">Three Phase General Purpose Dry Type Transformers 600V Or Less</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/three-phase-k-rated-non-linear-load-dry-type-transformers-600v-or-less">Three Phase K Rated Non Linear Load Dry Type Transformers 600V Or Less</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/three-phase-low-temperature-rise-dry-type-transformers-600v-or-less">Three Phase Low Temperature Rise Dry Type Transformers 600V Or Less</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/single-phase-non-ventilated-totally-enclosed-dry-type-transformers-600v-or-less">Single Phase Non Ventilated Totally Enclosed Dry Type Transformers 600V Or Less</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/electronic-transformers">Electronic Transformers</a>
                                      </li>
                                      <li>
                                          <a href="/collections/filters-conditioners">Filters & Conditioners</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/power-line-filters">Power Line Filters</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/transformer-conditioner-filter-accessories">Transformer, Conditioner & Filter Accessories</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/transformer-accessories-1">Transformer Accessories</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/uninterruptible-power-supplies">Uninterruptible Power Supplies</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/dc-power-supplies">Dc Power Supplies</a>
                                              </li>
                                          </ul>
                                      </li>
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/safety-switches-1">Safety Switches</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/disconnect-safety-switches">Disconnect Safety Switches</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/fusible-disconnect-safety-switches">Fusible Disconnect Safety Switches</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/non-fusible-disconnect-safety-switches">Non-Fusible Disconnect Safety Switches</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/double-throw-safety-switches">Double Throw Safety Switches</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/fusible-double-throw-safety-switches">Fusible Double Throw Safety Switches</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/non-fusible-double-throw-safety-switches">Non-Fusible Double Throw Safety Switches</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/general-duty-safety-switches">General Duty Safety Switches</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/fusible-general-duty-safety-switches">Fusible General Duty Safety Switches</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/non-fusible-general-duty-safety-switches">Non-Fusible General Duty Safety Switches</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/heavy-duty-safety-switches">Heavy Duty Safety Switches</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/non-fusible-heavy-duty-safety-switches">Non-Fusible Heavy Duty Safety Switches</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/fusible-heavy-duty-safety-switches">Fusible Heavy Duty Safety Switches</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/safety-switch-accessories">Safety Switch Accessories</a>
                                      </li>
                                      <li>
                                          <a href="/collections/special-application-safety-switches">Special Application Safety Switches</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/non-fusible-special-application-safety-switches">Non-Fusible Special Application Safety Switches</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/fusible-special-application-safety-switches">Fusible Special Application Safety Switches</a>
                                              </li>
                                          </ul>
                                      </li>
                                  </ul>
                              </li>
                          </ul>
                        </li>
                        </ul>

                        <ul class="first-level-menu" data-menu="Wiring & DataCom">
                        <li> <a href="/collections/wiring-devices-data-telecom-equipment">Wiring & DataCom</a>
                          <ul class="second-level-menu">
                              <li>
                                 <a href="/collections/central-control-devices-systems">Central Control Devices & Systems</a>
                              </li>
                              <li>
                                 <a href="/collections/consumer-packaged-wiring-devices">Consumer Packaged Wiring Devices</a>
                              </li>
                              <li>
                                  <a href="/collections/general-purpose-wiring-devices">General Purpose Wiring Devices</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/general-purpose-switches">General Purpose Switches</a>
                                      </li>
                                      <li>
                                          <a href="/collections/miscellaneous-wiring-devices">Miscellaneous Wiring Devices</a>
                                      </li>
                                      <li>
                                          <a href="/collections/pin-sleeve-devices">Pin & Sleeve Devices</a>
                                      </li>
                                      <li>
                                          <a href="/collections/plugs-conn-inlets-outlets-lampholdr">Plugs,Conn,Inlets,Outlets,Lampholdr</a>
                                      </li>
                                      <li>
                                          <a href="/collections/receptacles-surge-protectors">Receptacles & Surge Protectors</a>
                                      </li>
                                      <li>
                                          <a href="/collections/wall-plates-covers">Wall Plates & Covers</a>
                                      </li>
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/low-voltage-wiring-devices">Low-Voltage Wiring Devices</a>
                              </li>
                              <li>
                                  <a href="/collections/miniature-appliance-wiring-device">Miniature & Appliance Wiring Device</a>
                              </li>
                              <li>
                                  <a href="/collections/voice-data-video-equipment">Voice, Data, Video Equipment</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/cable-management-prot-dev">Cable Management & Prot Dev</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                <a href="/collections/cable-marking-labeling-equipment">Cable Marking & Labeling Equipment</a>
                                              </li>
                                          
                                              <li>
                                                <a href="/collections/firestopping-devices-materials">Firestopping Devices & Materials</a>
                                              </li>
                                          
                                              <li>
                                                <a href="/collections/grounding-bonding-equipment">Grounding & Bonding Equipment</a>
                                              </li>
                                          
                                              <li>
                                                <a href="/collections/power-supplies-upss-backup-equpt">Power Supplies-Ups'S & Backup Equpt</a>
                                              </li>
                                          
                                              <li>
                                                <a href="/collections/surge-suprsr-prot-dev-line-conditnr">Surge Suprsr-Prot Dev-Line Conditnr</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/connecting-devices">Connecting Devices</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/adapters">Adapters</a>
                                              </li>
                                          
                                              <li>
                                                  <a href="/collections/coaxial-twinaxial-connectors">Coaxial & Twinaxial Connectors</a>
                                              </li>
                                          
                                              <li>
                                                  <a href="/collections/coupler-splitter-switch-attenuator">Coupler,Splitter,Switch,Attenuator</a>
                                              </li>
                                          
                                              <li>
                                                  <a href="/collections/crossconnect-blocks-hardware">Crossconnect Blocks & Hardware</a>
                                              </li>
                                          
                                              <li>
                                                  <a href="/collections/fiber-optic-connectors">Fiber-Optic Connectors</a>
                                              </li>
                                          
                                              <li>
                                                  <a href="/collections/patch-panels">Patch Panels</a>
                                              </li>
                                          
                                              <li>
                                                  <a href="/collections/shielded-twisted-pair-connectors">Shielded Twisted-Pair Connectors</a>
                                              </li>
                                          
                                              <li>
                                                  <a href="/collections/unshielded-twisted-pair-connectors">Unshielded Twisted-Pair Connectors</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/distribution-devices">Distribution Devices</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/cable-hanging-management-accessor">Cable Hanging Management & Accessor</a>
                                              </li>
                                          
                                              <li>
                                                  <a href="/collections/distribution-frames-racksdis">Distribution Frames & Racksdis</a>
                                              </li>
                                          
                                              <li>
                                                  <a href="/collections/ducts-raceways-runways-trays">Ducts, Raceways, Runways, Trays</a>
                                              </li>
                                          
                                              <li>
                                                  <a href="/collections/enclosures-cabinets">Enclosures & Cabinets</a>
                                              </li>
                                          
                                              <li>
                                                  <a href="/collections/innerduct-accessories">Innerduct & Accessories</a>
                                              </li>
                                          
                                              <li>
                                                  <a href="/collections/junction-surface-back-boxes">Junction, Surface, & Back Boxes</a>
                                              </li>
                                          
                                              <li>
                                                  <a href="/collections/outlets-jacks-plates">Outlets, Jacks, & Plates</a>
                                              </li>
                                          
                                              <li>
                                                  <a href="/collections/splices-closures-trays">Splices, Closures, & Trays</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/electronic-network-devices">Electronic & Network Devices</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/concentrators-hubs">Concentrators & Hubs</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/elec-network-switches-kvm-switches">Elec/Network Switches Kvm Switches</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/multiplexrs-channel-or-dig-svc-unit">Multiplexrs-Channel Or Dig Svc Unit</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/power-supp-mod-interface-cards">Power Supp,Mod,Interface Cards</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/repeaters">Repeaters</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/routers-bridges">Routers & Bridges</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/transmitters-receivers">Transmitters & Receivers</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/power-test-equipment">Power & Test Equipment</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/cable-locators">Cable Locators</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/fault-finders">Fault Finders</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/multimeters">Multimeters</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/network-cable-testers">Network Cable Testers</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/power-meters">Power Meters</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/tone-generators-probes">Tone Generators & Probes</a>
                                              </li>
                                          </ul>
                                      </li>
                                  </ul>
                              </li>
                          </ul>
                        </li>
                        </ul>

                        <ul class="first-level-menu" data-menu="Conduit & Raceways">
                        <li> <a href="/collections/conduit-raceways">Conduit & Raceways</a>
                          <ul class="second-level-menu">
                              <li>
                                  <a href="/collections/cable-trays">Cable Trays</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/channel-cable-tray-accessories">Channel Cable Tray & Accessories</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                <a href="/collections/channel-cable-tray-accessories">Channel Cable Tray & Accessories</a>
                                              </li>
                                              <li>
                                                <a href="/collections/channel-cable-tray-splices">Channel Cable Tray Splices</a>
                                              </li>
                                              <li>
                                                <a href="/collections/channel-cable-tray-straight-sections">Channel Cable Tray Straight Sections</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/trough-cable-tray-accessories">Trough Cable Tray & Accessories</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/trough-cable-tray-accessories">Trough Cable Tray & Accessories</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/trough-cable-tray-fittings">Trough Cable Tray Fittings</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/trough-cable-tray-splices">Trough Cable Tray Splices</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/trough-cable-tray-straight-sections">Trough Cable Tray Straight Sections</a>
                                              </li>
                                          </ul>
                                      </li>
                                  </ul>
                              </li>
                              <li>
                                 <a href="/collections/emt-conduit">EMT Conduit</a>
                              </li>
                              <li>
                                 <a href="/collections/ent-conduit-fittings-accy">ENT Conduit, Fittings, & Accessories</a>
                              </li>
                              <li>
                                 <a href="/collections/fiberglass-conduit-fittings">Fiberglass Conduit & Fittings</a>
                              </li>
                              <li>
                                  <a href="/collections/flexible-conduit">Flexible Conduit</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/flex-non-metallic-conduit-tubing">Flex Non-Metallic Conduit & Tubing</a>
                                      </li>
                                      <li>
                                          <a href="/collections/flexible-metallic-conduit">Flexible Metallic Conduit</a>
                                      </li>
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/heavy-wall-conduit">Heavy Wall Conduit</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/aluminum-conduit">Aluminum Conduit</a>
                                      </li>
                                      <li>
                                          <a href="/collections/galvanized-rigid-steel-conduit">Galvanized Rigid Steel Conduit</a>
                                      </li>
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/intermediate-metal-conduit">Intermediate Metal Conduit</a>
                              </li>
                              <li>
                                  <a href="/collections/liquid-tight-conduit">Liquid Tight Conduit</a>
                              </li>
                              <li>
                                  <a href="/collections/pvc-conduit-ftgs-boxes">PVC Conduit, Fittings, & Boxes</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/pvc-conduit-bodies-fs-bx-junct-bx">PVC Conduit Bodies, Fuse Boxes, Junction Boxes</a>
                                      </li>
                                      <li>
                                          <a href="/collections/pvc-cond-clamps-straps-expan-cplg">PVC Conduit Clamps,Straps,Expansion Coupling</a>
                                      </li>
                                      <li>
                                          <a href="/collections/pvc-conduit-fittings-entrance-caps-accessories">PVC Conduit Fittings Entrance Caps & Accessories</a>
                                      </li>
                                      <li>
                                          <a href="/collections/p-c-elbows-fittings">PVC Elbows & Fittings</a>
                                      </li>
                                      <li>
                                          <a href="/collections/pvc-schedule-40-conduit">Pvc Schedule 40 Conduit</a>
                                      </li>
                                      <li>
                                          <a href="/collections/pvc-schedule-40-elbows">Pvc Schedule 40 Elbows</a>
                                      </li>
                                      <li>
                                          <a href="/collections/pvc-schedule-80-conduit">Pvc Schedule 80 Conduit</a>
                                      </li>
                                      <li>
                                          <a href="/collections/pvc-schedule-80-elbows">Pvc Schedule 80 Elbows</a>
                                      </li>
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/strips-surf-rcwys-pwrpole">Strips, Surface Raceways & Power Poles</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/metallic-raceway-accessories">Metallic Raceway & Accessories</a>
                                      </li>
                                      <li>
                                          <a href="/collections/non-metallic-raceway-accessories">Non-Metallic Raceway & Accessories</a>
                                      </li>
                                      <li>
                                          <a href="/collections/plug-outlet-strips-power-strips">Plug & Outlet Strips,Power Strips</a>
                                      </li>
                                      <li>
                                          <a href="/collections/tele-power-poles">Tele/Power Poles</a>
                                      </li>
                                      <li>
                                          <a href="/collections/wiring-duct-accessories">Wiring Duct & Accessories</a>
                                      </li>
                                  </ul>
                              </li>
                          </ul>
                        </li>
                        </ul>

                        <ul class="first-level-menu" data-menu="Lighting">
                        <li>
                          <a href="/collections/lighting">Lighting</a>
                          <ul class="second-level-menu">
                            <li>
                              <a href="/collections/ballasts">Ballasts</a>
                        
                              <ul class="third-level-menu">
                                  <li>
                                      <a href="/collections/combination-fans-lights-heaters">Combination Fans, Lights & Heaters</a>
                                  </li>
                                  <li>
                                      <a href="/collections/ballast-parts-accessories">Ballast Parts & Accessories</a>
                                      <ul class="fourth-level-menu">
                                          <li>
                                              <a href="/collections/ballast-accessories">Ballast Accessories</a>
                                          </li>
                                      </ul>
                                  </li>
                                  <li>
                                      <a href="/collections/emergency-ballasts">Emergency Ballasts</a>
                                      <ul class="fourth-level-menu">
                                          <li>
                                              <a href="/collections/fluorescent-emergency-ballasts">Fluorescent Emergency Ballasts</a>
                                          </li>
                                      </ul>
                                  </li>
                                  <li>
                                      <a href="/collections/fluorescent-ballasts">Fluorescent Ballasts</a>
                                      <ul class="fourth-level-menu">
                                          <li>
                                              <a href="/collections/dimming-fluorescent-ballasts">Dimming Fluorescent Ballasts</a>
                                          </li>
                                          <li>
                                              <a href="/collections/electronic-fluorescent-ballasts">Electronic Fluorescent Ballasts</a>
                                          </li>
                                      </ul>
                                  </li>
                                  <li>
                                      <a href="/collections/high-intensity-discharge-ballasts">High Intensity Discharge Ballasts</a>
                                      <ul class="fourth-level-menu">
                                          <li>
                                              <a href="/collections/electronic-hid-ballasts">Electronic High Intensity Discharge Ballasts</a>
                                          </li>                                      
                                          <li>
                                              <a href="/collections/hid-ballast-kits">High Intensity Discharge Ballast Kits</a>
                                          </li>                                      
                                          <li>
                                              <a href="/collections/magnetic-hid-ballasts">Magnetic High Intensity Discharge Ballasts</a>
                                          </li>                                      
                                          <li>
                                              <a href="/collections/pulse-start-hid-ballasts">Pulse Start High Intensity Discharge Ballasts</a>
                                          </li>
                                      </ul>
                                  </li>
                                  <li>
                                      <a href="/collections/led-emergency-drivers">Led Emergency Drivers</a>
                                  </li>
                                  <li>
                                      <a href="/collections/led-power-supplies">Led Power Supplies</a>
                                  </li>
                              </ul>
                            </li>
                            <li>
                              <a href="/collections/lamps">Lamps</a>
                              <ul class="third-level-menu">
                                  <li>
                                      <a href="/collections/fluorescent-lamps">Fluorescent Lamps</a>
                                      <ul class="fourth-level-menu">
                                          <li>
                                              <a href="/collections/compact-fluorescent-integrated-ballasted-lamps">Compact Fluorescent Integrated Ballasted Lamps</a>
                                          </li>                                      
                                          <li>
                                              <a href="/collections/compact-fluorescent-non-integrated-non-ballasted-lamps">Compact Fluorescent Non-Integrated Non-Ballasted Lamps</a>
                                          </li>                                      
                                          <li>
                                              <a href="/collections/linear-fluorescent-circular-lamps">Linear Fluorescent Circular Lamps</a>
                                          </li>                                      
                                          <li>
                                              <a href="/collections/linear-fluorescent-straight-lamps">Linear Fluorescent Straight Lamps</a>
                                          </li>                                      
                                          <li>
                                              <a href="/collections/linear-fluorescent-u-shape-lamps">Linear Fluorescent U-Shape Lamps</a>
                                          </li>
                                      </ul>
                                  </li>
                                  <li>
                                      <a href="/collections/halogen-lamps">Halogen Lamps</a>
                                      <ul class="fourth-level-menu">
                                          <li>
                                              <a href="/collections/halogen-a-line-bt-tb-shape-lamps">Halogen A-Line Bt, Tb Shape Lamps</a>
                                          </li>
                                          <li>
                                              <a href="/collections/halogen-decorative-b-f-g-t-shape-lamps">Halogen Decorative B, F, G, T, Shape Lamps</a>
                                          </li>
                                          <li>
                                              <a href="/collections/halogen-non-reflector-double-ended-t-shape-lamps">Halogen Non-Reflector Double Ended T Shape Lamps</a>
                                          </li>
                                          <li>
                                              <a href="/collections/halogen-non-reflector-single-ended-g-ps-t-shape-lamps">Halogen Non-Reflector Single Ended G, Ps, T Shape Lamps</a>
                                          </li>
                                          <li>
                                              <a href="/collections/halogen-parabolic-reflector-par-shape-lamps">Halogen Parabolic Reflector Par Shape Lamps</a>
                                          </li>
                                          <li>
                                              <a href="/collections/halogen-reflector-ar-br-jdr-mr-shape-lamps">Halogen Reflector Ar, Br, Jdr, Mr Shape Lamps</a>
                                          </li>
                                      </ul>
                                  </li>
                                  <li>
                                      <a href="/collections/hid-high-intensity-discharge-lamps">High Intensity Discharge Lamps</a>
                                      <ul class="fourth-level-menu">
                                          <li>
                                              <a href="/collections/hid-ceramic-metal-halide-lamps">High Intensity Discharge Ceramic Metal Halide Lamps</a>
                                          </li>                                      
                                          <li>
                                              <a href="/collections/hid-high-pressure-sodium-lamps">High Intensity Discharge High Pressure Sodium Lamps</a>
                                          </li>                                      
                                          <li>
                                              <a href="/collections/hid-mercury-vapor-lamps">High Intensity Discharge Mercury Vapor Lamps</a>
                                          </li>                                      
                                          <li>
                                              <a href="/collections/hid-quartz-metal-halide-lamps">High Intensity Discharge Quartz Metal Halide Lamps</a>
                                          </li>                                      
                                          <li>
                                              <a href="/collections/hid-specialty-lamps">High Intensity Discharge Specialty Lamps</a>
                                          </li>
                                      </ul>
                                  </li>
                                  <li>
                                      <a href="/collections/incandescent-lamps">Incandescent Lamps</a>
                                      <ul class="fourth-level-menu">
                                          <li>
                                              <a href="/collections/incandescent-a-line-a-p-ps-shape-lamps">Incandescent A-Line A, P, Ps Shape Lamps</a>
                                          </li>                                      
                                          <li>
                                              <a href="/collections/incandescent-appliance-indicator-s-shape-lamps">Incandescent Appliance & Indicator S Shape Lamps</a>
                                          </li>                                      
                                          <li>
                                              <a href="/collections/incandescent-decorative-b-c-ca-f-g-m-shape-lamps">Incandescent Decorative B, C, Ca, F, G, M Shape Lamps</a>
                                          </li>                                      
                                          <li>
                                              <a href="/collections/incandescent-parabolic-reflector-par-shape-lamps">Incandescent Parabolic Reflector Par Shape Lamps</a>
                                          </li>                                      
                                          <li>
                                              <a href="/collections/incandescent-reflector-r-br-er-shape-lamps">Incandescent Reflector R, Br, Er Shape Lamps</a>
                                          </li>                                      
                                          <li>
                                              <a href="/collections/incandescent-specialty-lamps">Incandescent Specialty Lamps</a>
                                          </li>                                      
                                          <li>
                                              <a href="/collections/incandescent-tubular-t-shape-lamps">Incandescent Tubular T Shape Lamps</a>
                                          </li>
                                      </ul>
                                  </li>
                                  <li>
                                      <a href="/collections/infrared-ultraviolet-germicidal-lamps">Infrared, Ultraviolet & Germicidal Lamps</a>
                                      <ul class="fourth-level-menu">
                                          <li>
                                            <a href="/collections/infrared-lamps">Infrared Lamps</a>
                                          </li>
                                      </ul>
                                  </li>
                                  <li>
                                      <a href="/collections/led-lamps-modules">LED Lamps & Modules</a>
                                      <ul class="fourth-level-menu">
                                          <li>
                                              <a href="/collections/led-a-line-a-shape-lamps">LED A-Line A Shape Lamps</a>
                                          </li>                                      
                                          <li>
                                              <a href="/collections/led-compact-fluorescent-integrated-non-integrated-lamps">LED Compact Fluorescent Integrated & Non-Integrated Lamps</a>
                                          </li>                                      
                                          <li>
                                              <a href="/collections/led-decorative-c-ca-f-g-shape-lamps">LED Decorative C, Ca, F, G Shape Lamps</a>
                                          </li>                                      
                                          <li>
                                              <a href="/collections/led-elliptical-e-shape-lamps">LED Elliptical E Shape Lamps</a>
                                          </li>                                      
                                          <li>
                                              <a href="/collections/led-linear-fluorescent-straight-u-shape-circular-lamps">LED Linear Fluorescent Straight, U-Shape & Circular Lamps</a>
                                          </li>                                      
                                          <li>
                                              <a href="/collections/led-parabolic-reflector-par-shape-lamps">LED Parabolic Reflector Par Shape Lamps</a>
                                          </li>                                      
                                          <li>
                                              <a href="/collections/led-reflector-gu-mr-r-shape-lamps">LED Reflector Gu, Mr R Shape Lamps</a>
                                          </li>
                                          <li>
                                              <a href="/collections/led-specialty-lamps-modules">LED Specialty Lamps & Modules</a>
                                          </li>
                                      </ul>
                                  </li>
                                  <li>
                                      <a href="/collections/miniature-automotive-sealed-beam-lamps">Miniature, Automotive & Sealed Beam Lamps</a>
                                      <ul class="fourth-level-menu">
                                          <li>
                                            <a href="/collections/miniature-lamps">Miniature Lamps</a>
                                          </li>
                                      </ul>
                                  </li>
                                  <li>
                                      <a href="/collections/photo-projection-display-stage-entertainment-lamps">Photo, Projection, Display, Stage & Entertainment Lamps</a>
                                      <ul class="fourth-level-menu">
                                          <li>
                                            <a href="/collections/projection-lamps">Projection Lamps</a>
                                          </li>
                                      </ul>
                                  </li>
                                  <li>
                                      <a href="/collections/shatter-resistant-specialty-lamps">Shatter Resistant & Specialty Lamps</a>
                                      <ul class="fourth-level-menu">
                                          <li>
                                            <a href="/collections/shatter-resistant-lamps">Shatter Resistant Lamps</a>
                                          </li>
                                      </ul>
                                  </li>
                              </ul>
                            </li>
                            <li>
                              <a href="/collections/lighting-controls-dimmers-sensors-systems">Lighting Controls, Dimmers, Sensors & Systems</a>
                              <ul class="third-level-menu">
                                  <li>
                                      <a href="/collections/lighting-controls">Lighting Controls</a>
                                  </li>
                                  <li>
                                      <a href="/collections/lighting-dimmers-dimming-systems">Lighting Dimmers & Dimming Systems</a>
                                      <ul class="fourth-level-menu">
                                          <li>
                                            <a href="/collections/lighting-dimmers">Lighting Dimmers</a>
                                          </li>
                                          <li>
                                            <a href="/collections/lighting-dimming-systems">Lighting Dimming Systems</a>
                                          </li>
                                      </ul>
                                  </li>
                                  <li>
                                      <a href="/collections/lighting-occupancy-sensors-motion-detectors">Lighting Occupancy Sensors & Motion Detectors</a>
                                      <ul class="fourth-level-menu">
                                          <li>
                                            <a href="/collections/lighting-motion-detectors">Lighting Motion Detectors</a>
                                          </li>
                                          <li>
                                            <a href="/collections/lighting-occupancy-sensors">Lighting Occupancy Sensors</a>
                                          </li>
                                      </ul>
                                  </li>
                                  <li>
                                      <a href="/collections/lighting-photocells-sensors">Lighting Photocells & Sensors</a>
                                      <ul class="fourth-level-menu">
                                          <li>
                                            <a href="/collections/lighting-photocells">Lighting Photocells</a>
                                          </li>
                                          <li>
                                            <a href="/collections/lighting-sensors">Lighting Sensors</a>
                                          </li>
                                      </ul>
                                  </li>
                                  <li>
                                      <a href="/collections/lighting-relays-panels-systems">Lighting Relays, Panels & Systems</a>
                                      <ul class="fourth-level-menu">
                                          <li>
                                            <a href="/collections/lighting-panels">Lighting Panels</a>
                                          </li>
                                          <li>
                                            <a href="/collections/lighting-relays">Lighting Relays</a>
                                          </li>
                                      </ul>
                                  </li>
                              </ul>
                            </li>
                            <li>
                              <a href="/collections/lighting-source">Lighting Source</a>
                              <ul class="third-level-menu">
                                  <li>
                                      <a href="/collections/fluorescent-lighting">Fluorescent Lighting</a>
                                      <ul class="fourth-level-menu">
                                          <li>
                                              <a href="/collections/fluorescent-architectural-specification-lighting">Fluorescent Architectural & Specification Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/fluorescent-canopy-parking-pole-mounted-roadway-lighting">Fluorescent Canopy, Parking, Pole Mounted & Roadway Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/fluorescent-chandeliers-decorative-table-floor-lighting">Fluorescent Chandeliers, Decorative, Table & Floor Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/fluorescent-floodlights-wallpacks-bollards-landscape-lighting">Fluorescent Floodlights, Wallpacks, Bollards & Landscape Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/fluorescent-general-purpose-lighting">Fluorescent General Purpose Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/fluorescent-hazardous-location-vapor-tight-lighting">Fluorescent Hazardous Location & Vapor Tight Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/fluorescent-high-abuse-wet-location-clean-room-medical-lighting">Fluorescent High Abuse, Wet Location, Clean Room & Medical Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/fluorescent-highbay-lowbay-industrial-lighting">Fluorescent Highbay, Lowbay & Industrial Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/fluorescent-track-rail-task-undercabinet-lighting">Fluorescent Track, Rail, Task & Undercabinet Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/fluorescent-recessed-architectural-specification-lighting">Fluorescent Recessed Architectural & Specification Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/fluorescent-surface-architectural-specification-lighting">Fluorescent Surface Architectural & Specification Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/fluorescent-suspended-architectural-specification-lighting">Fluorescent Suspended Architectural & Specification Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/fluorescent-wall-mounted-architectural-specification-lighting">Fluorescent Wall Mounted Architectural & Specification Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/fluorescent-pole-mounted-lighting">Fluorescent Pole Mounted Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/fluorescent-chandeliers">Fluorescent Chandeliers</a>
                                          </li>
                                          <li>
                                              <a href="/collections/fluorescent-floor-lamps">Fluorescent Floor Lamps</a>
                                          </li>
                                          <li>
                                              <a href="/collections/fluorescent-landscape-lighting">Fluorescent Landscape Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/fluorescent-surface-general-purpose-lighting">Fluorescent Surface General Purpose Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/fluorescent-hazardous-location-lighting">Fluorescent Hazardous Location Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/fluorescent-vapor-tight-lighting">Fluorescent Vapor Tight Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/fluorescent-high-abuse-lighting">Fluorescent High Abuse Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/fluorescent-wet-location-lighting">Fluorescent Wet Location Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/fluorescent-industrial-lighting">Fluorescent Industrial Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/fluorescent-rail-lighting">Fluorescent Rail Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/fluorescent-track-lighting">Fluorescent Track Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/fluorescent-undercabinet-lighting">Fluorescent Undercabinet Lighting</a>
                                          </li>
                                      </ul>
                                  </li>
                                  <li>
                                      <a href="/collections/halogen-quartz-lighting">Halogen & Quartz Lighting</a>
                                  </li>
                                  <li>
                                    <a href="/collections/high-intensity-discharge-lighting">High Intensity Discharge Lighting</a>
                                  </li>
                                  <li>
                                      <a href="/collections/incandescent-lighting">Incandescent Lighting</a>
                                      <ul class="fourth-level-menu">
                                          <li>
                                              <a href="/collections/incandescent-architectural-specification-lighting">Incandescent Architectural & Specification Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/incandescent-canopy-parking-pole-mounted-roadway-lighting">Incandescent Canopy, Parking, Pole Mounted & Roadway Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/incandescent-chandeliers-decorative-table-floor-lighting">Incandescent Chandeliers, Decorative, Table & Floor Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/incandescent-floodlights-wallpacks-bollards-landscape-lighting">Incandescent Floodlights, Wallpacks, Bollards & Landscape Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/incandescent-hazardous-location-vapor-tight-lighting">Incandescent Hazardous Location & Vapor Tight Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/incandescent-high-abuse-wet-location-clean-room-medical-lighting">Incandescent High Abuse, Wet Location, Clean Room & Medical Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/incandescent-track-rail-task-undercabinet-lighting">Incandescent Track, Rail, Task & Undercabinet Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/incandescent-recessed-architectural-specification-lighting">Incandescent Recessed Architectural & Specification Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/incandescent-surface-architectural-specification-lighting">Incandescent Surface Architectural & Specification Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/incandescent-suspended-architectural-specification-lighting">Incandescent Suspended Architectural & Specification Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/incandescent-wall-mounted-architectural-specification-lighting">Incandescent Wall Mounted Architectural & Specification Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/incandescent-pole-mounted-lighting">Incandescent Pole Mounted Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/incandescent-roadway-lighting">Incandescent Roadway Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/incandescent-chandeliers">Incandescent Chandeliers</a>
                                          </li>
                                          <li>
                                              <a href="/collections/incandescent-floodlights">Incandescent Floodlights</a>
                                          </li>
                                          <li>
                                              <a href="/collections/incandescent-landscape-lighting">Incandescent Landscape Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/incandescent-hazardous-location-lighting">Incandescent Hazardous Location Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/incandescent-vapor-tight-lighting">Incandescent Vapor Tight Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/incandescent-wet-location-lighting">Incandescent Wet Location Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/incandescent-rail-lighting">Incandescent Rail Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/incandescent-track-lighting">Incandescent Track Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/incandescent-undercabinet-lighting">Incandescent Undercabinet Lighting</a>
                                          </li>
                                      </ul>
                                  </li>
                                  <li>
                                      <a href="/collections/led-lighting">LED Lighting</a>
                                      <ul class="fourth-level-menu">
                                          <li>
                                              <a href="/collections/led-architectural-specification-lighting">LED Architectural & Specification Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/led-canopy-parking-pole-mounted-roadway-lighting">LED Canopy, Parking, Pole Mounted & Roadway Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/led-chandeliers-decorative-table-floor-lighting">LED Chandeliers, Decorative, Table & Floor Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/led-floodlights-wallpacks-bollards-landscape-lighting">LED Floodlights, Wallpacks, Bollards & Landscape Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/led-general-purpose-lighting">LED General Purpose Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/led-hazardous-location-vapor-tight-lighting">LED Hazardous Location & Vapor Tight Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/led-highbay-lowbay-industrial-lighting">LED Highbay, Lowbay & Industrial Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/led-track-rail-task-undercabinet-lighting">LED Track, Rail, Task & Undercabinet Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/led-recessed-architectural-specification-lighting">LED Recessed Architectural & Specification Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/led-surface-architectural-specification-lighting">LED Surface Architectural & Specification Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/led-suspended-architectural-specification-lighting">LED Suspended Architectural & Specification Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/led-wall-mounted-architectural-specification-lighting">LED Wall Mounted Architectural & Specification Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/led-canopy-lighting">LED Canopy Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/led-parking-lighting">LED Parking Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/led-pole-mounted-lighting">LED Pole Mounted Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/led-roadway-lighting">LED Roadway Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/led-chandeliers">LED Chandeliers</a>
                                          </li>
                                          <li>
                                              <a href="/collections/led-decorative-lighting">LED Decorative Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/led-bollards">LED Bollards</a>
                                          </li>
                                          <li>
                                              <a href="/collections/led-floodlights">LED Floodlights</a>
                                          </li>
                                          <li>
                                              <a href="/collections/led-landscape-lighting">LED Landscape Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/led-wallpacks">LED Wallpacks</a>
                                          </li>
                                          <li>
                                              <a href="/collections/led-surface-general-purpose-lighting">LED Surface General Purpose Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/led-suspended-general-purpose-lighting">LED Suspended General Purpose Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/led-hazardous-location-lighting">LED Hazardous Location Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/led-vapor-tight-lighting">LED Vapor Tight Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/led-highbay-lighting">LED Highbay Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/led-rail-lighting">LED Rail Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/led-task-lighting">LED Task Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/led-track-lighting">LED Track Lighting</a>
                                          </li>
                                          <li>
                                              <a href="/collections/led-undercabinet-lighting">LED Undercabinet Lighting</a>
                                          </li>
                                      </ul>
                                  </li>
                                  <li>
                                      <a href="/collections/lighting-lampholders">Lighting Lampholders</a>
                                      <ul class="fourth-level-menu">
                                          <li>
                                              <a href="/collections/compact-fluorescent-lampholders">Compact Fluorescent Lampholders</a>
                                          </li>                                      
                                          <li>
                                              <a href="/collections/halogen-lampholders">Halogen Lampholders</a>
                                          </li>                                      
                                          <li>
                                              <a href="/collections/hid-lampholders">High Intensity Discharge Lampholders</a>
                                          </li>                                      
                                          <li>
                                              <a href="/collections/incandescent-lampholders">Incandescent Lampholders</a>
                                          </li>                                      
                                          <li>
                                              <a href="/collections/linear-fluorescent-lampholders">Linear Fluorescent Lampholders</a>
                                          </li>
                                      </ul>
                                  </li>
                                  <li>
                                      <a href="/collections/lighting-parts-wiring-accessories">Lighting Parts, Wiring & Accessories</a>
                                      <ul class="fourth-level-menu">
                                          <li>
                                              <a href="/collections/lighting-accessories">Lighting Accessories</a>
                                          </li>                                      
                                          <li>
                                              <a href="/collections/lighting-glass">Lighting Glass</a>
                                          </li>                                      
                                          <li>
                                              <a href="/collections/lighting-globes">Lighting Globes</a>
                                          </li>                                      
                                          <li>
                                              <a href="/collections/lighting-guards">Lighting Guards</a>
                                          </li>                                      
                                          <li>
                                              <a href="/collections/lighting-lenses">Lighting Lenses</a>
                                          </li>                                      
                                          <li>
                                              <a href="/collections/lighting-modular-wiring">Lighting Modular Wiring</a>
                                          </li>                                      
                                          <li>
                                              <a href="/collections/lighting-reflectors">Lighting Reflectors</a>
                                          </li>
                                      </ul>
                                  </li>
                                  <li>
                                      <a href="/collections/lighting-poles-standards-brackets-crossarms">Lighting Poles, Standards, Brackets & Crossarms</a>
                                      <ul class="fourth-level-menu">
                                          <li>
                                              <a href="/collections/lighting-brackets">Lighting Brackets</a>
                                          </li>                                      
                                          <li>
                                              <a href="/collections/lighting-poles">Lighting Poles</a>
                                          </li>
                                      </ul>
                                  </li>
                                  <li>
                                      <a href="/collections/specialty-lighting">Specialty Lighting</a>
                                      <ul class="fourth-level-menu">
                                          <li>
                                              <a href="/collections/emergency-lighting-exit-signs-inverters">Emergency Lighting, Exit Signs &
                                                  Inverters</a>
                                          </li>                                      
                                          <li>
                                              <a href="/collections/flexible-fiber-optic-induction-lighting">Flexible, Fiber Optic & Induction
                                                  Lighting</a>
                                          </li>                                      
                                          <li>
                                              <a href="/collections/motion-activated-occupancy-sensing-lighting">Motion Activated & Occupancy Sensing
                                                  Lighting</a>
                                          </li>                                      
                                          <li>
                                              <a href="/collections/portable-worklight-lighting">Portable & Worklight Lighting</a>
                                          </li>                                      
                                          <li>
                                              <a href="/collections/safety-security-step-lights">Safety, Security & Step Lights</a>
                                          </li>
                                      </ul>
                                  </li>
                                </ul>
                              </li>
                            </ul>
                          </li>
                          </ul>
                          
                        <ul class="first-level-menu" data-menu="Controls">
                        <li> <a href="/collections/controls">Controls</a>
                          <ul class="second-level-menu">
                              <li>
                                  <a href="/collections/industrial-motor-controls">Industrial & Motor Controls</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/contactor-starter-renewal-parts">Contactor & Starter Renewal Parts</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/contactor-renewal-parts">Contactor Renewal Parts</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/starter-renewal-parts">Starter Renewal Parts</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/contactors">Contactors</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/definite-purpose-contactors">Definite Purpose Contactors</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/iec-contactors">IEC Contactors</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/lighting-contactors">Lighting Contactors</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/nema-contactors">NEMA Contactors</a>
                                              </li>
                                              <li >
                                                  <a href="/collections/special-purpose-contactors">Special Purpose Contactors</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/drives-accessories">Drives & Accessories</a>
                                          <ul class="fourth-level-menu">           
                                              <li>
                                                <a href="/collections/ac-drives">AC Drives</a>
                                              </li>
                                              <li>
                                                <a href="/collections/drive-accessories">Drive Accessories</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/motor-control-accessories">Motor Control Accessories</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/contactor-accessories">Contactor Accessories</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/starter-accessories">Starter Accessories</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/motor-control-centers-accessories">Motor Control Centers & Accessories</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/motor-control-center-accessories">Motor Control Center Accessories</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/motor-control-renewal-parts">Motor Control Renewal Part</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                <a href="/collections/disconnect-motor-switches-accessories">Disconnect Motor Switches & Accessories</a>
                                              </li>    
                                              <li>
                                                <a href="/collections/manual-motor-switches-accessories">Manual Motor Switches & Accessories</a>
                                              </li>
                                              <li>
                                                <a href="/collections/rotary-motor-switches-accessories">Rotary Motor Switches & Accessories</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/motor-control-starters-contactors">Motor Control Starters & Contactors</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/manual-starters">Manual Starters</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/nema-combination-starters">NEMA Combination Starters</a>
                                              </li>
                                              <li class=" mobile-hide">
                                                  <a href="/collections/nema-non-combination-starters">NEMA Non-Combination Starters</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/motor-starter-protectors">Motor Starter Protectors</a>
                                      </li>
                                      <li>
                                          <a href="/collections/thermal-overload-heater-elements">Thermal Overload Heater Elements</a>
                                      </li>
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/limit-switches-proximity-sensors-level-switches">Limit Switches, Proximity Sensors, Level Switches</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/level-float-switches">Level & Float Switches</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/level-switches-accessories">Level Switches & Accessories</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/limit-switches">Limit Switches</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/limit-switch-accessories">Limit Switch Accessories</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/limit-switch-arms-actuators-operators">Limit Switch Arms, Actuators & Operators</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/limit-switch-bodies">Limit Switch Bodies</a>
                                              </li>
                                              <li>
                                                  <a href="/collections/limit-switch-heads">Limit Switch Heads</a>
                                              </li>
                                              <li class=" mobile-hide">
                                                  <a href="/collections/miniature-snap-action-limit-switches">Miniature & Snap Action Limit Switches</a>
                                              </li>
                                              <li class=" mobile-hide">
                                                  <a href="/collections/severe-duty-limit-switches">Severe Duty Limit Switches</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                         <a href="/collections/sensor-devices-cables-accessories">Sensor Devices, Cables & Accessories</a>
                                         <ul class="fourth-level-menu">
                                            <li>
                                                <a href="/collections/photoelectric-sensors">Photoelectric Sensors</a>
                                            </li>
                                            <li>
                                                <a href="/collections/sensor-accessories">Sensor Accessories</a>
                                            </li>
                                            <li>
                                                <a href="/collections/sensor-cables">Sensor Cables</a>
                                            </li>
                                            <li>
                                                <a href="/collections/ultrasonic-sensors">Ultrasonic Sensors</a>
                                            </li>
                                        </ul>
                                      </li>
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/machine-safety-switches">Machine Safety Switches</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/cable-pull-switches-accessories">Cable Pull Switches & Accessories</a>
                                      </li>
                                      <li>
                                          <a href="/collections/magnetic-switches-accessories">Magnetic Switches & Accessories</a>
                                      </li>
                                  </ul>
                              </li>
                              <li>
                                 <a href="/collections/pressure-vacuum-switches">Pressure & Vacuum Switches</a>
                                 <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/pressure-switches">Pressure Switches</a>
                                      </li>
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/programmable-logic-automation-controllers">Programmable Logic & Automation Controllers</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/programmable-logic-automation-accessories">Programmable Logic & Automation Accessories</a>
                                      </li>
                                      <li>
                                          <a href="/collections/programmable-logic-automation-input-output-modules">Programmable Logic & Automation Input/Output Modules</a>
                                      </li>
                                      <li>
                                          <a href="/collections/programmable-logic-automation-interface-components">Programmable Logic & Automation Interface Components</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/programmable-logic-automation-power-supplies">Programmable Logic & Automation Power Supplies</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/programmable-logic-automation-programmers-software">Programmable Logic & Automation Programmers & Software</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/programmable-logic-automation-software">Programmable Logic & Automation Software</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/programmable-logic-automation-special-function-modules">Programmable Logic & Automation Special Function Modules</a>
                                      </li>
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/rlays-psh-btn-plt-lts-sel-sw">Relays, Push Buttons, Pilot Lights, Selector Switches</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/control-pendant-stations-accessories">Control & Pendant Stations & Accessories</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/control-station-accessories">Control Station Accessories</a>
                                              </li>                                          
                                              <li>
                                                  <a href="/collections/control-station-complete-assemblies">Control Station Complete Assemblies</a>
                                              </li>                                          
                                              <li>
                                                  <a href="/collections/control-station-cover-assemblies">Control Station Cover Assemblies</a>
                                              </li>                                          
                                              <li>
                                                  <a href="/collections/control-station-covers">Control Station Covers</a>
                                              </li>                                          
                                              <li>
                                                  <a href="/collections/control-station-enclosures">Control Station Enclosures</a>
                                              </li>                                          
                                              <li>
                                                  <a href="/collections/pendant-station-covers">Pendant Station Covers</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/push-buttons-pilot-lights-selector-switches-accessories">Push Buttons, Pilot Lights, Selector Switches & Accessories</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/contact-blocks">Contact Blocks</a>
                                              </li>                                          
                                              <li>
                                                  <a href="/collections/legend-plates">Legend Plates</a>
                                              </li>                                          
                                              <li>
                                                  <a href="/collections/pilot-light-complete-assemblies">Pilot Light Complete Assemblies</a>
                                              </li>                                          
                                              <li>
                                                  <a href="/collections/push-button-complete-assemblies">Push Button Complete Assemblies</a>
                                              </li>                                          
                                              <li>
                                                  <a href="/collections/push-button-components">Push Button Components</a>
                                              </li>                                          
                                              <li>
                                                  <a href="/collections/push-button-pilot-light-selector-switch-accessories">Push Button, Pilot Light, Selector Switch Accessories</a>
                                              </li>                                          
                                              <li>
                                                  <a href="/collections/selector-switch-complete-assemblies">Selector Switch Complete Assemblies</a>
                                              </li>                                          
                                              <li>
                                                  <a href="/collections/selector-switch-components">Selector Switch Components</a>
                                              </li>
                                          </ul>
                                      </li>
                                      <li>
                                          <a href="/collections/relays-push-buttons-pilot-lights-selector-switches">Relays, Push Buttons, Pilot Lights, Selector Switches</a>
                                          <ul class="fourth-level-menu">
                                              <li>
                                                  <a href="/collections/fault-or-failure-relays-accessories">Fault Or Failure Relays & Accessories</a>
                                              </li>                                          
                                              <li>
                                                  <a href="/collections/general-purpose-plug-in-relays-accessories">General Purpose Plug-In Relays & Accessories</a>
                                              </li>                                          
                                              <li>
                                                  <a href="/collections/general-purpose-power-relays-accessories">General Purpose Power Relays & Accessories</a>
                                              </li>                                          
                                              <li>
                                                  <a href="/collections/iec-control-relays-accessories">IEC Control Relays & Accessories</a>
                                              </li>                                          
                                              <li>
                                                  <a href="/collections/monitoring-relays-accessories">Monitoring Relays & Accessories</a>
                                              </li>                                          
                                              <li>
                                                  <a href="/collections/nema-control-relays-accessories">NEMA Control Relays & Accessories</a>
                                              </li>                                          
                                              <li>
                                                  <a href="/collections/overload-relays-accessories">Overload Relays & Accessories</a>
                                              </li>                                          
                                              <li>
                                                  <a href="/collections/timing-relays-accessories">Timing Relays & Accessories</a>
                                              </li>
                                          </ul>
                                      </li>
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/temperature-switches-controls">Temperature Switches & Controls</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/temperature-controls">Temperature Controls</a>
                                      </li>
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/time-switches-controls">Time Switches & Controls</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/electromechanical-time-switches">Electromechanical Time Switches</a>
                                      </li>
                                      <li>
                                          <a href="/collections/electronic-time-switches">Electronic Time Switches</a>
                                      </li>
                                      <li>
                                          <a href="/collections/mechanical-time-switches">Mechanical Time Switches</a>
                                      </li>
                                      <li>
                                          <a href="/collections/time-switch-accessories">Time Switch Accessories</a>
                                      </li>
                                  </ul>
                              </li>
                          </ul>
                        </li>
                        </ul>

                        <ul class="first-level-menu" data-menu="Brands">
                        <li> <a href="/pages/shop-by-brand">Brands</a>
                          <ul class="second-level-menu">
                              <li>
                                  <a href="/collections/0-9">0-9</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/3m">3M</a>
                                      </li>
                                      <li>
                                          <a href="/collections/3m-communication-technologies">3M Communication Technologies</a>
                                      </li>
                                      <li>
                                          <a href="/collections/3m-electrical">3M Electrical</a>
                                      </li>
                                      <li>
                                          <a href="/collections/3m-electrical-commercial-and-industrial">3M Electrical Commercial and Industrial</a>
                                      </li>
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/a">A</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/arlington-industries">Arlington Industries</a>
                                      </li>
                                      <li>
                                          <a href="/collections/a-g-manufacturing">A&G Manufacturing</a>
                                      </li>
                                      <li>
                                         <a href="/collections/acme-electric">Acme Electric</a>
                                      </li>
                                      <li>
                                         <a href="/collections/adorne">adorne</a>
                                      </li>
                                      <li>
                                         <a href="/collections/advance">Advance</a>
                                      </li>
                                      <li>
                                         <a href="/collections/afc-cable-systems">AFC Cable Systems</a>
                                      </li>
                                      <li>
                                         <a href="/collections/all-current-electrical-sales">All Current Electrical Sales</a>
                                      </li>
                                      <li>
                                         <a href="/collections/allfasteners-usa">Allfasteners USA</a>
                                      </li>
                                      <li>
                                         <a href="/collections/allied-building-products">Allied Building Products</a>
                                      </li>
                                      <li>
                                         <a href="/collections/allied-fittings">Allied Fittings</a>
                                      </li>
                                      <li>
                                         <a href="/collections/allied-moulded">Allied Moulded</a>
                                      </li>
                                      <li>
                                         <a href="/collections/american-polywater">American Polywater</a>
                                      </li>
                                      <li>
                                         <a href="/collections/ammo-international-inc">AMMO International</a>
                                      </li>
                                      <li>
                                         <a href="/collections/anamet-electrical">Anamet Electrical</a>
                                      </li>
                                      <li>
                                         <a href="/collections/appleton">Appleton</a>
                                      </li>
                                      <li>
                                         <a href="/collections/arlington-industries">Arlington Industries</a>
                                      </li>
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/b">B</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/b-line">B-Line</a>
                                      </li>
                                      <li>
                                          <a href="/collections/bell">Bell</a>
                                      </li>
                                      <li>
                                         <a href="/collections/bergen">Bergen</a>
                                      </li>
                                      <li>
                                         <a href="/collections/black-decker">Black & Decker</a>
                                      </li>
                                      <li>
                                         <a href="/collections/b-d-dewalt-oldham">Black & Decker Dewalt Oldham</a>
                                      </li>
                                      <li>
                                         <a href="/collections/blackburn">Blackburn</a>
                                      </li>
                                      <li>
                                         <a href="/collections/bridgeport-fittings">Bridgeport Fittings</a>
                                      </li>
                                      <li>
                                         <a href="/collections/briscon-electric-mfg-corp">Briscon Electric Mfg. Corp.</a>
                                      </li>
                                      <li>
                                         <a href="/collections/brk">BRK</a>
                                      </li>
                                      <li>
                                         <a href="/collections/broan">Broan</a>
                                      </li>
                                      <li>
                                         <a href="/collections/bryant">Bryant</a>
                                      </li>
                                      <li>
                                         <a href="/collections/burndy">Burndy</a>
                                      </li>
                                      <li>
                                         <a href="/collections/bussmann">Bussmann</a>
                                      </li>
                                  </ul>
                              </li>
                              <li>
                                 <a href="/collections/c">C</a>
                                 <ul class="third-level-menu">
                                      <li>
                                            <a href="/collections/cablofil">Cablofil</a>
                                        </li>
                                        <li>
                                            <a href="/collections/cadweld">Cadweld</a>
                                        </li>
                                        <li>
                                            <a href="/collections/calpipe-industries">CalPipe Industries</a>
                                        </li>
                                        <li>
                                            <a href="/collections/cantex">Cantex</a>
                                        </li>
                                        <li>
                                            <a href="/collections/carlon">Carlon</a>
                                        </li>
                                        <li>
                                            <a href="/collections/carrier">Carrier</a>
                                        </li>
                                        <li>
                                            <a href="/collections/casablanca-fan-co">Casablanca Fan Co.</a>
                                        </li>
                                        <li>
                                            <a href="/collections/catamount">Catamount</a>
                                        </li>
                                        <li>
                                            <a href="/collections/chatsworth-products">Chatsworth Products</a>
                                        </li>
                                        <li>
                                            <a href="/collections/coleman-cable">Coleman Cable</a>
                                        </li>
                                        <li>
                                            <a href="/collections/columbia-lighting">Columbia Lighting</a>
                                        </li>
                                        <li>
                                            <a href="/collections/condux-intl-inc">Condux Intl</a>
                                        </li>
                                        <li>
                                            <a href="/collections/connecticut-electric">Connecticut Electric</a>
                                        </li>
                                        <li>
                                            <a href="/collections/cooper-wiring-devices">Cooper Wiring Devices</a>
                                        </li>
                                        <li>
                                            <a href="/collections/craftmade">Craftmade</a>
                                        </li>
                                        <li>
                                            <a href="/collections/crouse-hinds">Crouse-Hinds</a>
                                        </li>
                                        <li>
                                            <a href="/collections/cutler-hammer">Cutler-Hammer</a>
                                        </li>
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/e">E</a>
                                  <ul class="third-level-menu">
                                      <li>
                                            <a href="/collections/e-box-enclosures-inc">E-Box Enclosures</a>
                                        </li>
                                        <li>
                                            <a href="/collections/easy-heat">Easy Heat</a>
                                        </li>
                                        <li>
                                            <a href="/collections/eaton">Eaton</a>
                                        </li>
                                        <li>
                                            <a href="/collections/edison">Edison</a>
                                        </li>
                                        <li>
                                            <a href="/collections/edwards-signaling">Edwards Signaling</a>
                                        </li>
                                        <li>
                                            <a href="/collections/eiko">EiKO</a>
                                        </li>
                                        <li>
                                            <a href="/collections/elco-lighting">Elco Lighting</a>
                                        </li>
                                        <li>
                                            <a href="/collections/electriflex">Electriflex</a>
                                        </li>
                                        <li>
                                            <a href="/collections/emergi-lite">Emergi-Lite</a>
                                        </li>
                                        <li>
                                            <a href="/collections/emerson">Emerson</a>
                                        </li>
                                        <li>
                                            <a href="/collections/empire-level-inc">Empire Level</a>
                                        </li>
                                        <li>
                                            <a href="/collections/engineered-products-company">Engineered Products Company</a>
                                        </li>
                                        <li>
                                            <a href="/collections/et2-contemporary-lighting">ET2 Contemporary Lighting</a>
                                        </li>
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/f">F</a>
                                  <ul class="third-level-menu">
                                      <li>
                                            <a href="/collections/fanimation">Fanimation</a>
                                        </li>
                                        <li>
                                            <a href="/collections/feiss-lighting">Feiss Lighting</a>
                                        </li>
                                        <li>
                                            <a href="/collections/fluke">Fluke</a>
                                        </li>
                                        <li>
                                            <a href="/collections/fulham">Fulham</a>
                                        </li>
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/g">G</a>
                                  <ul class="third-level-menu">
                                      <li>
                                            <a href="/collections/galvan-industries">Galvan Industries</a>
                                        </li>
                                        <li>
                                            <a href="/collections/gardner-bender">Gardner Bender</a>
                                        </li>
                                        <li>
                                            <a href="/collections/garvin-industries">Garvin Industries</a>
                                        </li>
                                        <li>
                                            <a href="/collections/gb2">GB2</a>
                                        </li>
                                        <li>
                                            <a href="/collections/generic">Generic</a>
                                        </li>
                                        <li>
                                            <a href="/collections/globe-electric-company-usa">Globe Electric Company USA</a>
                                        </li>
                                        <li>
                                            <a href="/collections/golden-lighting">Golden Lighting</a>
                                        </li>
                                        <li>
                                            <a href="/collections/greaves">Greaves</a>
                                        </li>
                                        <li>
                                            <a href="/collections/greenlee">Greenlee</a>
                                        </li>
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/h">H</a>
                                  <ul class="third-level-menu">
                                      <li>
                                            <a href="/collections/halex">Halex</a>
                                        </li>
                                        <li>
                                            <a href="/collections/hammond-power-solutions">Hammond Power Solutions</a>
                                        </li>
                                        <li>
                                            <a href="/collections/harger">Harger</a>
                                        </li>
                                        <li>
                                            <a href="/collections/hilti-inc">Hilti</a>
                                        </li>
                                        <li>
                                            <a href="/collections/hinkley-lighting">Hinkley Lighting</a>
                                        </li>
                                        <li>
                                            <a href="/collections/homac">Homac</a>
                                        </li>
                                        <li>
                                            <a href="/collections/honeywell">Honeywell</a>
                                        </li>
                                        <li>
                                            <a href="/collections/howard-industries">Howard Industries</a>
                                        </li>
                                        <li>
                                            <a href="/collections/hubbardton-forge">Hubbardton Forge</a>
                                        </li>
                                        <li>
                                            <a href="/collections/hubbell">Hubbell</a>
                                        </li>
                                        <li>
                                            <a href="/collections/hubbell-industrial-controls">Hubbell Industrial Controls</a>
                                        </li>
                                        <li>
                                            <a href="/collections/hubbell-industrial-lighting">Hubbell Industrial Lighting</a>
                                        </li>
                                        <li>
                                            <a href="/collections/hubbell-premise-wiring">Hubbell Premise Wiring</a>
                                        </li>
                                        <li>
                                            <a href="/collections/hubbell-wiring-device-kellems">Hubbell Wiring Device-Kellems</a>
                                        </li>
                                        <li>
                                            <a href="/collections/hunter-fan-company">Hunter Fan Company</a>
                                        </li>
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/i">I</a>
                                  <ul class="third-level-menu">
                                      <li>
                                            <a href="/collections/ideal-industries">IDEAL Industries</a>
                                        </li>
                                        <li>
                                            <a href="/collections/ilsco">ILSCO</a>
                                        </li>
                                        <li>
                                            <a href="/collections/intermatic">Intermatic</a>
                                        </li>
                                        <li>
                                            <a href="/collections/international-tool-mfg">International Tool Mfg.</a>
                                        </li>
                                        <li>
                                            <a href="/collections/ipex">IPEX</a>
                                        </li>
                                        <li>
                                            <a href="/collections/irwin">Irwin</a>
                                        </li>
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/j">J</a>
                                  <ul class="third-level-menu">
                                      <li>
                                            <a href="/collections/jefferson-electric">Jefferson Electric</a>
                                        </li>
                                        <li>
                                            <a href="/collections/juno-lighting">Juno Lighting</a>
                                        </li>
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/k">K</a>
                                  <ul class="third-level-menu">
                                      <li>
                                            <a href="/collections/keystone">Keystone</a>
                                        </li>
                                        <li>
                                            <a href="/collections/kichler">Kichler</a>
                                        </li>
                                        <li>
                                            <a href="/collections/kidde">Kidde</a>
                                        </li>
                                        <li>
                                            <a href="/collections/killark">Killark</a>
                                        </li>
                                        <li>
                                            <a href="/collections/kindorf">Kindorf</a>
                                        </li>
                                        <li>
                                            <a href="/collections/klein-tools">Klein Tools</a>
                                        </li>
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/l">L</a>
                                  <ul class="third-level-menu">
                                      <li>
                                            <a href="/collections/l-h-dottie">L.H. Dottie</a>
                                        </li>
                                        <li>
                                            <a href="/collections/legrand">Legrand</a>
                                        </li>
                                        <li>
                                            <a href="/collections/leviton">Leviton</a>
                                        </li>
                                        <li>
                                            <a href="/collections/lew-electric-fittings">Lew Electric Fittings</a>
                                        </li>
                                        <li>
                                            <a href="/collections/lightolier">Lightolier</a>
                                        </li>
                                        <li>
                                            <a href="/collections/lithonia-lighting">Lithonia Lighting</a>
                                        </li>
                                        <li>
                                            <a href="/collections/littelfuse">Littelfuse</a>
                                        </li>
                                        <li>
                                            <a href="/collections/louisville-ladder">Louisville Ladder</a>
                                        </li>
                                        <li>
                                            <a href="/collections/lps">LPS</a>
                                        </li>
                                        <li>
                                            <a href="/collections/lutron">Lutron</a>
                                        </li>
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/m">M</a>
                                  <ul class="third-level-menu">
                                      <li>
                                            <a href="/collections/morris-products-inc">Morris Products</a>
                                        </li>
                                        <li>
                                            <a href="/collections/marley-engineered-products">Marley Engineered Products</a>
                                        </li>
                                        <li>
                                            <a href="/collections/maxim-lighting">Maxim Lighting</a>
                                        </li>
                                        <li>
                                            <a href="/collections/maxlite">MaxLite</a>
                                        </li>
                                        <li>
                                            <a href="/collections/mc-gill-mfg-co">Mc Gill Mfg Co</a>
                                        </li>
                                        <li>
                                            <a href="/collections/meltric">Meltric </a>
                                        </li>
                                        <li>
                                            <a href="/collections/mersen">Mersen</a>
                                        </li>
                                        <li>
                                            <a href="/collections/metallics">Metallics</a>
                                        </li>
                                        <li>
                                            <a href="/collections/middle-atlantic-products">Middle Atlantic Products</a>
                                        </li>
                                        <li>
                                            <a href="/collections/midwest-electric-products">Midwest Electric Products</a>
                                        </li>
                                        <li>
                                            <a href="/collections/milbank">Milbank</a>
                                        </li>
                                        <li>
                                            <a href="/collections/minerallac">Minerallac</a>
                                        </li>
                                        <li>
                                            <a href="/collections/monte-carlo">Monte Carlo</a>
                                        </li>
                                        <li>
                                            <a href="/collections/mulberry-metal-products">Mulberry Metal Products</a>
                                        </li>
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/n">N</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/na-industries-international-corp">Na Industries International Corp.</a>
                                      </li>
                                      <li>
                                          <a href="/collections/new-priceline">New Priceline</a>
                                      </li>
                                      <li>
                                          <a href="/collections/nora-lighting">Nora Lighting</a>
                                      </li>
                                      <li>
                                          <a href="/collections/nsi-industries">NSi Industries</a>
                                      </li>
                                      <li>
                                          <a href="/collections/nutone">NuTone</a>
                                      </li>
                                      <li>
                                          <a href="/collections/nuvo">NuVo</a>
                                      </li>
                                      <li>
                                          <a href="/collections/nuvo-lighting">Nuvo Lighting</a>
                                      </li>
                                      <li>
                                          <a href="/collections/nvent">nVent</a>
                                      </li>
                                      <li>
                                          <a href="/collections/nvent-caddy">nVent Caddy</a>
                                      </li>
                                      <li>
                                          <a href="/collections/nvent-erico">nVent Erico</a>
                                      </li>
                                      <li>
                                          <a href="/collections/nvent-eriflex">nVent Eriflex</a>
                                      </li>
                                      <li>
                                          <a href="/collections/nvent-hoffman">nVent Hoffman</a>
                                      </li>
                                      <li>
                                          <a href="/collections/nvent-raychem">nVent Raychem</a>
                                      </li>
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/o">O</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/orbit-industries-inc">Orbit Industries Inc.</a>
                                      </li>
                                      <li>
                                          <a href="/collections/o-z-gedney">O-Z Gedney</a>
                                      </li>
                                      <li>
                                          <a href="/collections/ocal">Ocal</a>
                                      </li>
                                      <li>
                                          <a href="/collections/on-q">On-Q</a>
                                      </li>
                                      <li>
                                          <a href="/collections/orbit-industries">Orbit Industries</a>
                                      </li> 
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/p">P</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/panasonic">Panasonic</a>
                                      </li>
                                      <li>
                                          <a href="/collections/pass-seymour">Pass & Seymour</a>
                                      </li>
                                      <li>
                                          <a href="/collections/peco">PECO</a>
                                      </li>
                                      <li>
                                          <a href="/collections/perma-cote">Perma-Cote</a>
                                      </li>
                                      <li>
                                          <a href="/collections/philips">Philips</a>
                                      </li>
                                      <li>
                                          <a href="/collections/philips-lighting">Philips Lighting</a>
                                      </li>
                                      <li>
                                          <a href="/collections/picoma-industries">Picoma Industries</a>
                                      </li>
                                      <li>
                                          <a href="/collections/powers-fasteners">Powers Fasteners</a>
                                      </li>
                                      <li>
                                          <a href="/collections/progress-lighting">Progress Lighting</a>
                                      </li> 
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/r">R</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/rab">RAB</a>
                                      </li>
                                      <li>
                                          <a href="/collections/rack-a-tiers">Rack-A-Tiers</a>
                                      </li>
                                      <li>
                                          <a href="/collections/raco">RACO</a>
                                      </li>
                                      <li>
                                          <a href="/collections/radiant">Radiant</a>
                                      </li>
                                      <li>
                                          <a href="/collections/rayovac">Rayovac</a>
                                      </li>
                                      <li>
                                          <a href="/collections/rectorseal">RectorSeal</a>
                                      </li>
                                      <li>
                                          <a href="/collections/red-dot">Red Dot</a>
                                      </li>
                                      <li>
                                          <a href="/collections/remke">Remke</a>
                                      </li>
                                      <li>
                                          <a href="/collections/ridgid">Ridgid</a>
                                      </li>
                                      <li>
                                          <a href="/collections/robroy-industries">Robroy Industries</a>
                                      </li> 
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/s">S</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/satco">Satco</a>
                                      </li>
                                      <li>
                                          <a href="/collections/sea-gull-lighting">Sea Gull Lighting</a>
                                      </li>
                                      <li>
                                          <a href="/collections/seatek-company-inc">Seatek Company</a>
                                      </li>
                                      <li>
                                          <a href="/collections/sensor-switch-motion-controls">Sensor Switch Motion Controls</a>
                                      </li>
                                      <li>
                                          <a href="/collections/siemens">Siemens</a>
                                      </li>
                                      <li>
                                          <a href="/collections/southwire">Southwire</a>
                                      </li>
                                      <li>
                                          <a href="/collections/specified-technologies">Specified Technologies</a>
                                      </li>
                                      <li>
                                          <a href="/collections/square-d">Square D</a>
                                      </li>
                                      <li>
                                          <a href="/collections/stanley">Stanley</a>
                                      </li>
                                      <li>
                                          <a href="/collections/stanley-concrete-masonry-tools">Stanley Concrete & Masonry Tools</a>
                                      </li>
                                      <li>
                                          <a href="/collections/steel-city">Steel City</a>
                                      </li>
                                      <li>
                                          <a href="/collections/steel-electric-products">Steel Electric Products</a>
                                      </li>
                                      <li>
                                          <a href="/collections/stonco">Stonco</a>
                                      </li>
                                      <li>
                                          <a href="/collections/superstrut">Superstrut</a>
                                      </li>
                                      <li>
                                          <a href="/collections/sylvania">Sylvania</a>
                                      </li>
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/t">T</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/taymac">TayMac</a>
                                      </li>
                                      <li>
                                          <a href="/collections/tech-lighting">Tech Lighting</a>
                                      </li>
                                      <li>
                                          <a href="/collections/teddico-bwf">Teddico/BWF</a>
                                      </li>
                                      <li>
                                          <a href="/collections/thomas-betts">Thomas & Betts</a>
                                      </li>
                                      <li>
                                          <a href="/collections/tpi">TPI</a>
                                      </li>
                                      <li>
                                          <a href="/collections/ty-rap">Ty-Rap</a>
                                      </li>
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/u">U</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/unistrut">Unistrut</a>
                                      </li>
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/v">V</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/versabar">Versaba</a>
                                      </li>
                                      <li>
                                          <a href="/collections/victor-specialties">Victor Specialties</a>
                                      </li>
                                  </ul>
                              </li>
                              <li>
                                  <a href="/collections/w">W</a>
                                  <ul class="third-level-menu">
                                      <li>
                                          <a href="/collections/wac-lighting">WAC Lighting </a>
                                      </li>
                                      <li>
                                          <a href="/collections/wattstopper">WattStopper</a>
                                      </li>
                                      <li>
                                          <a href="/collections/wd-40">WD-40</a>
                                      </li>
                                      <li>
                                          <a href="/collections/werner">Werner</a>
                                      </li>
                                      <li>
                                          <a href="/collections/westinghouse-electric">Westinghouse Electric</a>
                                      </li>
                                      <li>
                                          <a href="/collections/westinghouse-lighting">Westinghouse Lighting</a>
                                      </li>
                                      <li>
                                          <a href="/collections/wiremold">Wiremold</a>
                                      </li>
                                  </ul>
                              </li>
                          </ul>
                        </li>
                        </ul>
                        
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- ==== End Collection List ==== -->

          
          ${data.facets.map(
            facet =>
              html`
                <div
                  class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}"
                >
                <input
                    class="ais-dropdown-checkbox"
                    type="checkbox"
                    id="${facet.escapedName}"
                    name="dropdown"
                  />
                  
                  <label
                    for="${facet.escapedName}"
                    class="ais-range-slider--header ais-facet--header ais-header"
                    >${facet.title}</label
                  >
                  
                  <div
                    class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"
                  ></div>
                </div>
              `
          )}
        </div>
        <div class="ais-block">
          <div class="ais-search-header">
            <div class="ais-stats-container"></div>
            
            <div class="ais-sort">
              ${data.multipleSortOrders
                ? html`
                    
                    <span class="ais-sort-orders-container"></span>
                  `
                : html`
                    ${algoliaShopify.translations.sortBy}
                    ${algoliaShopify.translations.relevance}
                  `}
            </div>

            <div class="ais-change-display">
              <span class="ais-change-display-block"
                ><i class="fa fa-th-large"></i
              ></span>
              <span class="ais-change-display-list ais-change-display-selected"
                ><i class="fa fa-th-list"></i
              ></span>
            </div>
            
          </div>
          <div class="ais-hits-container ais-results-as-list product-items"></div>
          <div class="ais-pagination-container"></div>
        </div>
      </div>
    `;
  });

  algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function(_defaultTemplate, hit, html, components) {
    // console.log("hit", hit);
    // console.log(hit.compare_at_price);

    const soEligible = specialOrder.isEligible(hit);
    const soInventory = specialOrder.inventory(hit);
    const soIsSpecial = specialOrder.isSpecialOrder(hit, specialOrder.minQty(hit));
    const soMaxQty = soEligible ? 999999 : (hit.variants_inventory_count || 99);
    const soAtcLabel = soIsSpecial ? 'Special Order' : algoliaShopify.translations.addToCart;
    const soAtcLabelMobile = soIsSpecial ? 'Special Order' : 'Add';

    return html`
    <div class="has-form li" role="none">
      <div class="ais--hit ais--product product-item-wrapper">
        <div class="ais-hit--image-wrapper">
          <a class="ais-hit--image-wrapper-link" href="/products/${hit.handle}">
            <img
              class="ais-hit--picture"
              src="${algoliaShopify.helpers.mediumImage(hit)}"
              alt="${hit.title} - ${hit.variant_title}"
            />
          </a>
          <p class="ais-hit--quickshop link-btn secondary-btn">
            <a class="qsButton overlay-tertiary" href="/products/${hit.handle}" data-quickshop="">Quick view</a>
          </p>
          <p><div class="th_wl_col_btn" data-product_id="${hit.id}" data-variant_id="${hit.objectID}"></div></p>
        </div>
        <div class="ais-hit--details">
          <div class="flex-hit--details">
            <div class="title-hit--details">
              <p class="ais-hit--title">
                <a
                  data-algolia-index="${hit.index}"
                  data-algolia-position="${hit.productPosition}"
                  data-algolia-queryid="${hit.queryID}"
                  data-algolia-objectid="${hit.objectID}"
                  href="${algoliaShopify.helpers.instantsearchLink(hit)}"
                  onclick="void(0)"
                  title="${algoliaShopify.helpers.fullTitle(
                    hit.title,
                    hit._distinct,
                    hit.variant_title
                  )}"
                >
                  ${components.Highlight({ attribute: 'title', hit })}
                  ${algoliaShopify.helpers.variantTitleAddition(hit, hit._distinct)}
                </a>
              </p>

              ${hit.meta && hit.meta.custom && hit.meta.custom.short_description &&
              html`
                <div class="info size-12 desktop-only" style="display: none">
                  <p>${hit.meta.custom.short_description}</p>
                </div>
              `}

              <div class="brand-hit--details">
                ${hit.vendor &&
                html`
                  <p><span class="algolia-vendor-txt small"><strong>Brand:</strong> ${components.Highlight({ attribute: 'vendor', hit })}</span></p>
                `}

                <p><span class="algolia-part-txt small">
                    <strong>Part:</strong> #${hit.meta.custom.manufacturer_catalog_number}
                </span></p>

                <p><span class="algolia-part-txt small">
                    <strong>UPC:</strong> ${components.Highlight({ attribute: 'barcode', hit })}
                </span></p>
              </div>

          
            </div>
            <div class="price-hit--details">
              ${hit.can_order
                ? html`
                    <p class="price ${hit.compare_at_price ? html`compare_price` : html`no_compare_price`}">
                        <span class="ais-hit--price-striked">
                        <span>${algoliaShopify.helpers.displayStrikedPrice(hit.price, hit.compare_at_price )}</span>
                        </span>
                        ${algoliaShopify.helpers.displayPrice(hit, hit._distinct)}
                        
                        ${hit.meta && hit.meta.custom && hit.meta.custom.uom &&
                        html`
                        <span> per ${hit.meta.custom.uom}</span>
                        `}
                        ${hit.meta && hit.meta.custom && hit.meta.custom.selling_qty_increments &&
                        html`
                        <p> sold in increments of ${hit.meta.custom.selling_qty_increments} ${hit.meta.custom.uom}</p>
                        `}
                    </p>
                    `
                : html`
                    <p data-text="Out of stock price not displayed."></p>
                `}

              ${hit.can_order
              ? html`
                  <p class="stock has-value overlay-valid list-hide"><span class="indicator"></span>${hit.inventory_quantity} in stock</p>
                `
              : html`
                  <p class="stock overlay-error list-hide s1tt-cont" title="Out of stock, Call 1-866-853-4768 for availability and price.">Out of stock, <span> Call 1-866-853-4768 for availability and price.</span></p>
                `}

              ${hit.variants_count > 1
              ? html`
              <p class="link-btn ais-hit--choose-options">
              
                <div class="qty-input">
                  <button class="qty-count qty-count--minus" data-action="minus" type="button">-</button>
                  ${hit.meta && hit.meta.custom && hit.meta.custom.selling_qty_min
                  ? html`
                    <input type="number" class="product-qty" name="product-qty" value="${hit.meta.custom.selling_qty_min}" min="${hit.meta.custom.selling_qty_min}" max="${soMaxQty}" step="${hit.meta.custom.selling_qty_increments}" required="" />`
                  : html`
                    <input type="number" class="product-qty" name="product-qty" value="1" min="1" max="${soMaxQty}" step="1" required="" />
                  `}
                  <button class="qty-count qty-count--add" data-action="add" type="button">+</button>
                </div>
                <div class="wrap-ais--view-product">
                  <div class="inner-view-product link-btn secondary-btn">
                  <a href="${algoliaShopify.helpers.instantsearchLink(hit)}" class="ais-hit--view-product overlay-tertiary" aria-label="View Product" style="margin: 0;">
                  <span class="mobile-hide">Choose Options</span>
                  <span class="mobile-only">Choose Options</span></a>
                  </div>
                </div>
              </p>`
              : html` 
                <p>
                ${hit._distinct && html`<form method="post" action="/cart/add" id="quick-add-template--17739524145377__main-collection${hit.objectID}" accept-charset="UTF-8" class="f8pr form-card" enctype="multipart/form-data" novalidate="novalidate">
                  <input type="hidden" name="form_type" value="product" style="z-index: 71;" />
                  <input type="hidden" name="utf8" value="✓" style="z-index: 70;" />
                  
                  <fieldset class="wrap-product-fieldset ${hit.can_order ? html`ais-hit--addable`: html`ais-hit--notaddable`} ${soIsSpecial ? 'ais-hit--special-order' : ''}"
                    data-special-order-eligible="${soEligible ? 'true' : 'false'}"
                    data-inventory-quantity="${String(soInventory)}"
                    style="z-index: 69;">

                      <input type="hidden" name="id" value="${hit.objectID}" style="z-index: 68;" />

                      <div class="qty-input">
                        <button class="qty-count qty-count--minus" data-action="minus" type="button">-</button>
                        ${hit.meta && hit.meta.custom && hit.meta.custom.selling_qty_min
                        ? html`
                          <input type="number" class="product-qty" name="product-qty" value="${hit.meta.custom.selling_qty_min}" min="${hit.meta.custom.selling_qty_min}" max="${soMaxQty}" step="${hit.meta.custom.selling_qty_increments}" required="" />`
                        : html`
                          <input type="number" class="product-qty" name="product-qty" value="1" min="1" max="${soMaxQty}" step="1" required="" />
                        `}
                        <button class="qty-count qty-count--add" data-action="add" type="button">+</button>
                      </div>
                      
                        <p class="submit" style="z-index: 67;">
                            
                            <span class="input-amounts input-amount-listenings"><span class="semantic-amounts">
                              <input type="number" class="ais-hit-quantity__input" id="quantity-quick-add-template--17739524145377__main-collection${hit.objectID}" name="quantity" value="${hit.meta.custom.selling_qty_min}" min="${hit.meta.custom.selling_qty_min}" max="${soMaxQty}" step="${hit.meta.custom.selling_qty_increments}" required="" />
                            </span></span>
                            
                            ${hit.can_order
                            ? html`
                              <button type="submit" class="ais-hit--atc overlay-tertiary" aria-label="Add to cart" data-vid="${hit.objectID}" style="margin: 0;">
                                  <span class="ais-hit--atc-label mobile-hide" data-default-label="${algoliaShopify.translations.addToCart}">${soAtcLabel}</span>
                                  <span class="ais-hit--atc-label mobile-only" data-default-label="Add">${soAtcLabelMobile}</span>
                              </button>`
                            : html`
                              <button class="overlay-tertiary disabled" style="margin: 0;">
                                ${algoliaShopify.translations.outOfStock}
                              </button>
                            `}
                          
                        </p>
                        <p class="ais-hit--special-order-message">⚠️ ${specialOrder.message(hit)}</p>
                    </fieldset>
                    <input type="hidden" name="product-id" value="${hit.objectID}" style="z-index: 66;" />
                    <input type="hidden" name="section-id" value="template--17609068019937__main-collection" style="z-index: 65;" />
                  </form>
                `}
                </p>
              `}
            </div>
          </div>
        </div>
        
      </div>
    </div>
    `;
  });

  algoliaShopify.hooks.registerHook('beforeAutocompleteMainTemplate', function(_defaultTemplate, templateOptions, elements, displaySuggestions) {
    const { html } = templateOptions;
    return html`
      <div class="aa-PanelLayout aa-Panel--scrollable">
        <div class="aa-PanelSections">
          <div class="aa-PanelSection--left">
            ${displaySuggestions &&
              html`
                <div class="aa-SourceHeader">
                  <span class="aa-SourceHeaderTitle"
                    >${algoliaShopify.translations.suggestions}</span
                  >
                  <div class="aa-SourceHeaderLine" />
                </div>
                ${elements.querySuggestionsPlugin}
              `}
            ${elements.collections} ${elements.articles} ${elements.pages}
            ${elements.redirectUrlPlugin}
          </div>
          <div class="aa-PanelSection--right">
            ${elements.products}
          </div>
        </div>
      </div>
    `;
  });

  algoliaShopify.hooks.registerHook('beforeAutocompleteMainProductsTemplate', function(_defaultTemplate, templateOptions, elements) {
    const { html } = templateOptions;
    return html`
      <div class="aa-PanelLayout aa-Panel--scrollable">
        <div class="aa-PanelSection">
          ${elements.products}
        </div>
      </div>
    `;
  });

  algoliaShopify.hooks.registerHook('beforeAutocompleteNoResultsTemplate', function(_defaultTemplate, templateOptions) {
    const { html, state } = templateOptions;
    return html`
      <div class="aa-PanelLayout aa-Panel--scrollable">
        <p class="aa-NoResultsHeader">
          ${algoliaShopify.translation_helpers.no_result_for(state.query)}
        </p>
        <a class="aa-NoResultsLink" href="${window.Shopify.routes.root}search?q=">
          ${algoliaShopify.translations.allProducts}
        </a>
      </div>
    `;
  });

  algoliaShopify.hooks.registerHook('beforeAutocompleteHeaderTemplate', function(_defaultTemplate, templateOptions, resource) {
    const { html, state } = templateOptions;
    return html`
      <div class="aa-SourceHeader">
        <span class="aa-SourceHeaderTitle">
          ${algoliaShopify.translation_helpers.render_title(
            resource,
            state.query
          )}
        </span>
        <div class="aa-SourceHeaderLine" />
      </div>
    `;
  });

  algoliaShopify.hooks.registerHook('beforeAutocompleteFooterTemplate', function(_defaultTemplate, templateOptions) {
    const { html, state } = templateOptions;
    return html`
      <div class="aa-footer">
        <a
          class="aa-SeeAllBtn"
          href="${window.Shopify.routes.root}search?q=${state.query}"
        >
          ${algoliaShopify.translations.allProducts}
          (${algoliaShopify.helpers.formatNumber(state.context.nbProducts)})
        </a>
      </div>
    `;
  });

  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteProductTemplate",
    function (_defaultTemplate, templateOptions, distinct, itemLink) {
      // Modify default options, then return them
      const { html, item, components } = templateOptions;
      return html`
    <a
      href="${itemLink}"
      class="aa-ItemLink aa-ProductItem"
      onClick="${(event) => handleItemClick(event, item)}"
    >
      <div class="aa-ItemContent">
        <div class="aa-ItemPicture aa-ItemPicture--loaded">
          <img
            src="${algoliaShopify.helpers.compactImage(item)}"
            alt="${item.title}"
          />
        </div>
        <div class="aa-ItemContentBody">
          <div class="aa-ItemContentBrand">
            ${hit.vendor && components.Highlight({ attribute: 'vendor', hit })}
          </div>
          <div class="aa-ItemContentTitleWrapper">
            <div class="aa-ItemContentTitle">
              ${components.Highlight({ hit: item, attribute: "title" })}
              <span class="algolia-variant">
                ${algoliaShopify.helpers.variantTitleAddition(item, distinct)}
              </span>
            </div>
          </div>
          <div class="aa-ItemContentPrice">
            <div class="aa-ItemContentPriceCurrent">
              ${algoliaShopify.helpers.displayPrice(item, distinct)}
            </div>
          </div>
        </div>
      </div>
    </a>
  `;
    }
  );

  algoliaShopify.hooks.registerHook('beforeAutocompleteArticlesTemplate', function(_defaultTemplate, templateOptions, itemLink) {
    const { html, item, components } = templateOptions;
    return html`
      <a href="${itemLink}" class="aa-ItemLink">
        <div class="aa-ItemWrapper">
          <div class="aa-ItemContent">
            <div class="aa-ItemIcon aa-ItemIcon--noBorder">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
                />
              </svg>
            </div>
            <div class="aa-ItemContentBody">
              <div class="aa-ItemContentTitle">
                ${components.Highlight({ hit: item, attribute: 'title' })}
              </div>
            </div>
          </div>
        </div>
      </a>
    `;
  });

  algoliaShopify.hooks.registerHook('beforeAutocompleteCollectionsTemplate', function(_defaultTemplate, templateOptions, itemLink) {
    const { html, item, components } = templateOptions;
    return  html`
      <a href="${itemLink}" class="aa-ItemLink">
        <div class="aa-ItemWrapper">
          <div class="aa-ItemContent">
            <div class="aa-ItemIcon aa-ItemIcon--noBorder">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
                />
              </svg>
            </div>
            <div class="aa-ItemContentBody">
              <div class="aa-ItemContentTitle">
                ${components.Highlight({ hit: item, attribute: 'title' })}
              </div>
            </div>
          </div>
        </div>
      </a>
    `;
  });

  algoliaShopify.hooks.registerHook('beforeAutocompletePagesTemplate', function(_defaultTemplate, templateOptions, itemLink) {
    const { html, item, components } = templateOptions;
    return html`
      <a href="${itemLink}" class="aa-ItemLink aa-ProductItem">
        <div class="aa-ItemWrapper">
          <div class="aa-ItemContent">
            <div class="aa-ItemIcon aa-ItemIcon--noBorder">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            <div class="aa-ItemContentBody">
              <div class="aa-ItemContentTitle">
                ${components.Highlight({ hit: item, attribute: 'title' })}
              </div>
            </div>
          </div>
        </div>
      </a>
    `;
  });

  algoliaShopify.hooks.registerHook('beforeAutocompleteSuggestionsTemplate', function(_defaultTemplate, templateOptions) {
    const { html, state } = templateOptions;
    return html`
      <a
        class="aa-ItemLink aa-ItemWrapper"
        href="${window.Shopify.routes.root}search?q=${item.query}"
      >
        <div class="aa-ItemContent">
          <div class="aa-ItemIcon aa-ItemIcon--noBorder">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M16.041 15.856c-0.034 0.026-0.067 0.055-0.099 0.087s-0.060 0.064-0.087 0.099c-1.258 1.213-2.969 1.958-4.855 1.958-1.933 0-3.682-0.782-4.95-2.050s-2.050-3.017-2.050-4.95 0.782-3.682 2.050-4.95 3.017-2.050 4.95-2.050 3.682 0.782 4.95 2.050 2.050 3.017 2.050 4.95c0 1.886-0.745 3.597-1.959 4.856zM21.707 20.293l-3.675-3.675c1.231-1.54 1.968-3.493 1.968-5.618 0-2.485-1.008-4.736-2.636-6.364s-3.879-2.636-6.364-2.636-4.736 1.008-6.364 2.636-2.636 3.879-2.636 6.364 1.008 4.736 2.636 6.364 3.879 2.636 6.364 2.636c2.125 0 4.078-0.737 5.618-1.968l3.675 3.675c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414z" />
            </svg>
          </div>
          <div class="aa-ItemContentBody">
            <div class="aa-ItemContentTitle">
              ${components.Highlight({ hit: item, attribute: 'query' })}
            </div>
          </div>
        </div>
        <div class="aa-ItemActions">
          <button
            class="aa-ItemActionButton"
            title={"Fill query with ${item.query}"}
          >
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M8 17v-7.586l8.293 8.293c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414l-8.293-8.293h7.586c0.552 0 1-0.448 1-1s-0.448-1-1-1h-10c-0.552 0-1 0.448-1 1v10c0 0.552 0.448 1 1 1s1-0.448 1-1z" />
            </svg>
          </button>
        </div>
      </a>
    `;
  });

  algoliaShopify.hooks.registerHook('beforeAutocompleteHeaderTemplate', function(_defaultTemplate, templateOptions, resource) {
    // Modify default options, then return them
    const { html, state } = templateOptions;
    const { query } = state;
    return html`
      <div class="aa-SourceHeader">
        <span class="aa-SourceHeaderTitle">
          ${`Results for "${query}"`}
        </span>
        <div class="aa-SourceHeaderLine" />
      </div>
    `;
  });

  algoliaShopify.hooks.registerHook('beforeInstantSearchAllowParamsArray', function(allowParamsArray) {
    // Modify default array, then return an array
    // allowParamsArray.push('ref');
    // return allowParamsArray;

    allowParamsArray = Array.isArray(allowParamsArray) ? allowParamsArray : [];
    allowParamsArray.push('ref');

    return allowParamsArray;
  });

  algoliaShopify.hooks.registerHook('beforeInstantSearchFiltersString', function(defaultFilter) {
    // Modify or replace the default string, then return a string
    if(defaultFilter) {
      return defaultFilter
    }
    else {
      return ''
    }
  });

  algoliaShopify.hooks.registerHook('beforeInstantSearchNoResultTemplate', function(_defaultTemplate, html) {
    return html`
      <div class="ais-hit-empty">
        <div class="ais-hit-empty--title">
          ${algoliaShopify.translations.noResultFound}
        </div>
        <div class="ais-hit-empty--clears">
          ${algoliaShopify.translations.try} ${' '}
          <a class="ais-hit-empty--clear-filters ais-link">
            ${algoliaShopify.translations.clearFilters} ${' '}
          </a>
          ${algoliaShopify.translations.or} ${' '}
          <a class="ais-hit-empty--clear-input ais-link">
            ${algoliaShopify.translations.changeInput}
          </a>
        </div>
      </div>
    `;
  });

  algoliaShopify.hooks.registerHook('beforeInstantSearchFacetItemTemplate', function(_defaultTemplate, item, html) {
    return html`
      <label class="${item.cssClasses.label}">
        ${item.type === 'disjunctive' &&
          (item.isRefined
            ? html`
                <input
                  type="checkbox"
                  class="${item.cssClasses.checkbox}"
                  checked
                />
              `
            : html`
                <input type="checkbox" class="${item.cssClasses.checkbox}" />
              `)}
        ${item.label}
        <span class="${item.cssClasses.count}">
          ${algoliaShopify.helpers.formatNumber(item.count)}
        </span>
      </label>
    `;
  });

algoliaShopify.hooks.registerHook('beforeInstantSearchShowMoreTemplate', function(_defaultTemplate, data, html) {
    return html`
      <span
        >${data.isShowingMore
          ? algoliaShopify.translations.showLess
          : algoliaShopify.translations.showMore}</span
      >
    `;
});

    algoliaShopify.hooks.registerHook('beforeISStartAddWidgetArray', async function() {
        const { searchBox } = window.algoliaShopify.externals.widgets;

        // Fetch IP directly
        async function getClientIP() {
            const res = await fetch("https://api.ipify.org?format=json");
            const json = await res.json();
            return json.ip;
        }

        const var_ip = await getClientIP();
        document.body.setAttribute("data-visitor-ip", var_ip);

        let user_flag = true;

        if (document.body.getAttribute('data-user') === 'internal') {
            user_flag = false;
            console.log("Analytics disabled: data-user=internal");
        }

        // const excludedIPs = ["171.50.184.56", "49.36.81.222"];
        const excludedIPs = ["192.168.1.209", "108.58.178.26", "75.99.85.194", "192.168.1.122", "10.50.1.129", "73.233.43.91", "99.189.0.55", "171.50.184.56", "49.36.81.222"];
        if (excludedIPs.includes(var_ip)) {
            user_flag = false;
            console.log("Analytics disabled: excluded IP", var_ip);
        }

        console.log("Final analytics flag:", user_flag);

        return [
            searchBox({
            container: '#algolia-search',
            analytics: user_flag
            })
        ];
    });

  /*
  algoliaShopify.hooks.registerHook('beforeISStartAddWidgetArray', function() {
    // Please be aware not all widgets are available
    const { searchBox } = window.algoliaShopify.externals.widgets;

    const searchBoxWidget = searchBox({
      container: '#search-box'
    });

    return [searchBoxWidget];
  });

  algoliaShopify.hooks.registerHook('beforeInstantSearchStatsTemplate', function() {
    // Please be aware not all widgets are available
    const { searchStats } = window.algoliaShopify.externals.widgets;

    const searchStatsWidget = searchStats({
      container: '.ais-stats-container'
    });
    return [searchStatsWidget];
  });
  */

  algoliaShopify.hooks.registerHook('beforeAlgoliaAnalyticsOptions', function(options) {
    // Modify default options, then return them
    options.userToken = 'a76b78778efcb02038c6b897695ea6ba'; // random UUID;
    return options;
  });

  algoliaShopify.hooks.registerHook('beforeAddToCartSelectorString', function(_selector) {
    // The default selector is '[name="add"]'
    // Return a CSS selector
    return '#add-to-cart';
  });

  algoliaShopify.hooks.registerHook('beforeInstantSearchFacetLimitNumber', function(limit) {
    return 100;
  });
});


const handleItemClick = (e, line_item) => {
  const afterClick = new Event("algoliaShopify.autocomplete.hitClickAction");
  document.dispatchEvent(afterClick);

  if (algoliaShopify.config.analytics_enabled) {
    const clickData = {
      index: line_item.__autocomplete_indexName,
      eventName: "Added to cart",
      queryID: line_item.__autocomplete_queryID,
      objectIDs: [line_item.objectID],
    };
    algoliaShopify.saveForConversionTracking(clickData);
  }

  const customerCustomAction = algoliaShopify.hooks.triggerHooks(
    "afterAutocompleteProductClickAction",
    undefined,
    line_item
  );

  if (typeof customerCustomAction === "function") {
    customerCustomAction();
  }
};


/* ================= InstantSearch hooks =================== */




/*
document.addEventListener("DOMContentLoaded", (e) => {
  console.log("Yes", e);

document.querySelectorAll('.ais-hit--quickshop a').forEach(function($ps_this, $idx){
  $ps_this.classList.add('quickshop-initialized');
  $ps_this.addEventListener('click', function(event){
    event.preventDefault(), event.stopImmediatePropagation();
    $ps_this.classList.add('loading');
    event.preventDefault();
    quickshopContainer.innerHTML = '';
    openQuickshop($ps_this);
  });
});
    
openQuickshop = function($ps_this) {
  var quickshopUrl = $ps_this.getAttribute('href');
  fetch(quickshopUrl)
    .then((response) => {
      if (!response.ok) {
        var error = new Error(response.status);
        throw error;
      }
      return response.text();
    })
    .then((text) => {
      const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('div[id$="main-product"]'),
            container = resultsMarkup.querySelector('.m6pr'),
            sectionId = container.getAttribute('data-template');
      container.classList.add('m6pr-compact');
      container.classList.remove('m6pr');
      if (resultsMarkup.querySelector('#section-info')) { resultsMarkup.querySelector('#section-info').remove(); };
      if (resultsMarkup.querySelector('.product-recommendations')) { resultsMarkup.querySelector('.product-recommendations').remove(); };
      if (resultsMarkup.querySelector('header.mobile-hide')) { resultsMarkup.querySelector('header.mobile-hide').remove(); }
      if (resultsMarkup.querySelector('header.mobile-only')) { resultsMarkup.querySelector('header.mobile-only').classList.remove('mobile-only'); }
      if (resultsMarkup.querySelector('.l4pr.no-thumbs-mobile')) { resultsMarkup.querySelector('.l4pr.no-thumbs-mobile').classList.add('no-thumbs-desktop'); }
      Array.from(resultsMarkup.querySelectorAll('a[href="#section-info"], a[href="#section-reviews"]')).forEach(function ($ps_this) {
          $ps_this.setAttribute('href', quickshopUrl + $ps_this.getAttribute('href'));
      });
      Array.from(resultsMarkup.querySelectorAll('.pickup, .has-social, .syk-x')).forEach(function ($ps_this) {
          $ps_this.remove();
      });
      resultsMarkup.querySelector('header > h1, header > h2, header > h3').innerHTML = '<a href="'+ quickshopUrl +'">' + resultsMarkup.querySelector('header > h1, header > h2, header > h3').innerHTML + '</a>';
      resultsMarkup.innerHTML = resultsMarkup.innerHTML.replaceAll(sectionId, `quickshop-${ sectionId }`);
      handleQuickshopPanel(resultsMarkup.innerHTML, $ps_this);
    })
    .catch((error) => {
      console.log("openQuickshop error", error);
      throw error;
    });
}
    
handleQuickshopPanel = function(resultsMarkup, $ps_this) {
  quickshopContainer.innerHTML = resultsMarkup;
  window.dispatchEvent(modulePanelEvt);
  window.dispatchEvent(semanticInputEvt);
  window.dispatchEvent(ratingsEvt);
  window.dispatchEvent(productVariantsEvt);
  window.dispatchEvent(productOptionsEvt);
  window.dispatchEvent(listProductSliderEvt);
  window.dispatchEvent(listDropEvt);
  window.dispatchEvent(semanticSelectEvt);
  window.dispatchEvent(showHideDataElementEvt);
  window.dispatchEvent(sellingplansEvt);
  window.dispatchEvent(pickupAvailabilityEvt);
  window.dispatchEvent(modulePanelAnchorEvt);
  window.dispatchEvent(formZindexEvt);
  window.dispatchEvent(fancyboxEvt);
  window.dispatchEvent(accordeonEvt);
  window.dispatchEvent(dataChangeEvt);
  window.dispatchEvent(countdownEvt);
  window.dispatchEvent(schemeTooltipEvt);
  window.dispatchEvent(popupsEvt);
  window.dispatchEvent(rangeSliderEvt);
  upsellPopup.init();
  if (window.Shopify && Shopify.PaymentButton) {
      Shopify.PaymentButton.init();
  }
  setTimeout(function () {
      window.dispatchEvent(removeSDCcssEvt);
  },1);
  ajaxCart.init();
  if (window.ProductModel) window.ProductModel.loadShopifyXR();
  openPanel('quickshop');
  $ps_this.classList.remove('loading');
}

});

*/

document.addEventListener('algolia.instantSearch.onRender', function() {

    const mediaQuery = window.matchMedia('(max-width: 831px)');

    function autoClickFacets() {
        if (!mediaQuery.matches) return;

        const facetsBtn = document.querySelector('.is-collections--all .ais-facets-button');
        if (facetsBtn) {
            facetsBtn.click();
        }
    }

    // Run once after Algolia init
    autoClickFacets();

  document.querySelectorAll('.ais-hit--quickshop a').forEach(function($ps_this, $idx){
    $ps_this.classList.add('quickshop-initialized');
    $ps_this.addEventListener('click', function(event){
      event.preventDefault(), event.stopImmediatePropagation();
      $ps_this.classList.add('loading');
      event.preventDefault();
      quickshopContainer.innerHTML = '';
      openQuickshop($ps_this);
    });
  });
      
  openQuickshop = function($ps_this) {
    var quickshopUrl = $ps_this.getAttribute('href');
    fetch(quickshopUrl)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('div[id$="main-product"]'),
              container = resultsMarkup.querySelector('.m6pr'),
              sectionId = container.getAttribute('data-template');
        container.classList.add('m6pr-compact');
        container.classList.remove('m6pr');
        if (resultsMarkup.querySelector('#section-info')) { resultsMarkup.querySelector('#section-info').remove(); };
        if (resultsMarkup.querySelector('.product-recommendations')) { resultsMarkup.querySelector('.product-recommendations').remove(); };
        if (resultsMarkup.querySelector('header.mobile-hide')) { resultsMarkup.querySelector('header.mobile-hide').remove(); }
        if (resultsMarkup.querySelector('header.mobile-only')) { resultsMarkup.querySelector('header.mobile-only').classList.remove('mobile-only'); }
        if (resultsMarkup.querySelector('.l4pr.no-thumbs-mobile')) { resultsMarkup.querySelector('.l4pr.no-thumbs-mobile').classList.add('no-thumbs-desktop'); }
        Array.from(resultsMarkup.querySelectorAll('a[href="#section-info"], a[href="#section-reviews"]')).forEach(function ($ps_this) {
            $ps_this.setAttribute('href', quickshopUrl + $ps_this.getAttribute('href'));
        });
        Array.from(resultsMarkup.querySelectorAll('.pickup, .has-social, .syk-x')).forEach(function ($ps_this) {
            $ps_this.remove();
        });
        resultsMarkup.querySelector('header > h1, header > h2, header > h3').innerHTML = '<a href="'+ quickshopUrl +'">' + resultsMarkup.querySelector('header > h1, header > h2, header > h3').innerHTML + '</a>';
        resultsMarkup.innerHTML = resultsMarkup.innerHTML.replaceAll(sectionId, `quickshop-${ sectionId }`);
        handleQuickshopPanel(resultsMarkup.innerHTML, $ps_this);
      })
      .catch((error) => {
        console.error("openQuickshop error", error);
        throw error;
      });
  }
      
  handleQuickshopPanel = function(resultsMarkup, $ps_this) {
    quickshopContainer.innerHTML = resultsMarkup;
    window.dispatchEvent(modulePanelEvt);
    window.dispatchEvent(semanticInputEvt);
    window.dispatchEvent(ratingsEvt);
    window.dispatchEvent(productVariantsEvt);
    window.dispatchEvent(productOptionsEvt);
    window.dispatchEvent(listProductSliderEvt);
    window.dispatchEvent(listDropEvt);
    window.dispatchEvent(semanticSelectEvt);
    window.dispatchEvent(showHideDataElementEvt);
    window.dispatchEvent(sellingplansEvt);
    window.dispatchEvent(pickupAvailabilityEvt);
    window.dispatchEvent(modulePanelAnchorEvt);
    window.dispatchEvent(formZindexEvt);
    window.dispatchEvent(fancyboxEvt);
    window.dispatchEvent(accordeonEvt);
    window.dispatchEvent(dataChangeEvt);
    window.dispatchEvent(countdownEvt);
    window.dispatchEvent(schemeTooltipEvt);
    window.dispatchEvent(popupsEvt);
    window.dispatchEvent(rangeSliderEvt);
    upsellPopup.init();
    if (window.Shopify && Shopify.PaymentButton) {
      Shopify.PaymentButton.init();
    }
    setTimeout(function () {
      window.dispatchEvent(removeSDCcssEvt);
    },1);
    ajaxCart.init();
    if (window.ProductModel) window.ProductModel.loadShopifyXR();
    openPanel('quickshop');
    $ps_this.classList.remove('loading');
  }

  if(typeof ajaxCart == 'object'){
    ajaxCart.init();
  }

  document.querySelectorAll('#algolia-shopify-instantsearch .ais-facet-dropdown-wrapper').forEach(($filter_this, $filter_idx) => {
    if($filter_this.querySelector('.ais-RefinementList-list') || $filter_this.querySelector('.ais-facet-price-container')){
      $filter_this.classList.add('show_algolia_filter');
      if($filter_this.classList.contains('hide_algolia_filter')){
        $filter_this.classList.remove('hide_algolia_filter');
      }
    } else{
      $filter_this.classList.add('hide_algolia_filter');
      if($filter_this.classList.contains('show_algolia_filter')){
        $filter_this.classList.remove('show_algolia_filter');
      }
    }
  });

  // var algolia_semanticInputEvt = new CustomEvent("semanticInput");
  // window.dispatchEvent(algolia_semanticInputEvt);


  /* ==== Custom Qty input + Special Order state ==== */

  function refreshSpecialOrder(fieldset, qty) {
    if (!fieldset) return;

    const eligible = fieldset.getAttribute('data-special-order-eligible') === 'true';
    const inventory = parseFloat(fieldset.getAttribute('data-inventory-quantity')) || 0;
    const qtyField = fieldset.querySelector('.product-qty');

    let wanted = parseFloat(qty);
    if (isNaN(wanted)) wanted = parseFloat(qtyField && qtyField.value) || 0;

    const isSpecial = eligible && wanted > inventory;

    fieldset.classList.toggle('ais-hit--special-order', isSpecial);

    fieldset.querySelectorAll('.ais-hit--atc-label').forEach(function (label) {
      label.textContent = isSpecial
        ? 'Special Order'
        : (label.getAttribute('data-default-label') || label.textContent);
    });

    let property = fieldset.querySelector('.ais-hit--special-order-property');
    if (isSpecial && !property) {
      property = document.createElement('input');
      property.type = 'hidden';
      property.className = 'ais-hit--special-order-property';
      property.name = 'properties[_SpecialOrder]';
      property.value = 'true';
      fieldset.appendChild(property);
    } else if (!isSpecial && property) {
      property.remove();
    }
  }

  document.querySelectorAll('.wrap-product-fieldset').forEach(function (fieldset) {
    refreshSpecialOrder(fieldset);
  });

  const qtyContainers = document.querySelectorAll(".ais-hit--addable .qty-input");

  qtyContainers.forEach(container => {
      const minusBtn = container.querySelector(".qty-count--minus");
      const plusBtn = container.querySelector(".qty-count--add");
      const inputField = container.querySelector(".product-qty");
      const fieldset = container.closest(".wrap-product-fieldset");
      const qtyInputElement = fieldset.querySelector(".ais-hit-quantity__input");

      function updateDisplay(value) {
        if (qtyInputElement) {
          qtyInputElement.value = value;
        }
        inputField.value = value;
        refreshSpecialOrder(fieldset, value);
      }

    //   let qtyStep = parseFloat(inputField.getAttribute('step')) || 1;
    //   let minValue = parseInt(inputField.getAttribute('min'), 10) || 0;
    //   let maxValue = parseInt(inputField.getAttribute('max'), 10) || 99;

      let qtyStep = parseFloat(inputField.getAttribute('step')) || 1;
      let minValue = parseInt(inputField.getAttribute('min'), 10);
      let maxValue = parseInt(inputField.getAttribute('max'), 10);
      if (isNaN(minValue)) minValue = 1;
      if (isNaN(maxValue)) maxValue = 99;

      minusBtn.addEventListener("click", function () {
          let currentValue = parseInt(inputField.value, 10) || minValue;
          if (currentValue > minValue) {
              currentValue -= qtyStep;
              if (currentValue < minValue) currentValue = minValue;
          }
          updateDisplay(currentValue);
      });

      plusBtn.addEventListener("click", function () {
          let currentValue = parseInt(inputField.value, 10) || minValue;
          if (currentValue < maxValue) {
              currentValue += qtyStep;
              if (currentValue > maxValue) currentValue = maxValue;
          }
          updateDisplay(currentValue);
      });

      inputField.addEventListener("change", function () {
          let value_cst = parseInt(inputField.value, 10) || minValue;
          if (isNaN(value_cst) || value_cst < minValue) {
              value_cst = minValue;
          } else if (value_cst > maxValue) {
              value_cst = maxValue;
          } else {
              value_cst = Math.round(value_cst / qtyStep) * qtyStep;
          }
          updateDisplay(value_cst);
      });

      updateDisplay(inputField.value);
  });

  /* ==== End Custom Qty input ==== */
  

  /* ==== By Category Filter ==== */

  var requestPath = document.querySelector('body').dataset.path;
  
  // Hide all second, third, and fourth level menus initially
  document.querySelectorAll(".second-level-menu, .third-level-menu, .fourth-level-menu").forEach(menu => {
      menu.style.display = "none";
  });
  
  document.querySelectorAll('.ais-RefinementList-list a').forEach($this => {
      let hrefPath = new URL($this.href, window.location.origin).pathname;
  
      if (hrefPath === requestPath) {
          let firstLevel = $this.closest(".first-level-menu");
          let secondLevel = $this.closest(".second-level-menu");
          let thirdLevel = $this.closest(".third-level-menu");
          let fourthLevel = $this.closest(".fourth-level-menu");
  
          if (fourthLevel) {
              // If match is found in fourth level, show third, second, and first levels
              fourthLevel.style.display = "block";
              if (thirdLevel) thirdLevel.style.display = "block";
              if (secondLevel) secondLevel.style.display = "block";
              if (firstLevel) firstLevel.style.display = "block";
          } else if (thirdLevel) {
              // If match is found in third level, show second and first levels
              thirdLevel.style.display = "block";
              if (secondLevel) secondLevel.style.display = "block";
              if (firstLevel) firstLevel.style.display = "block";
  
              // Show all fourth-level menus under this third-level menu
              thirdLevel.querySelectorAll(".fourth-level-menu").forEach(fourthMenu => {
                  fourthMenu.style.display = "block";
              });
          } else if (secondLevel) {
              // If match is found in second level, show first and second levels
              secondLevel.style.display = "block";
              if (firstLevel) firstLevel.style.display = "block";
  
              // Show all third and fourth-level menus under this second-level menu
              secondLevel.querySelectorAll(".third-level-menu").forEach(thirdMenu => {
                  thirdMenu.style.display = "block";
                  thirdMenu.querySelectorAll(".fourth-level-menu").forEach(fourthMenu => {
                      fourthMenu.style.display = "block";
                  });
              });
          } else if (firstLevel) {
              // If match is found in first level, show only second level
              firstLevel.style.display = "block";
  
              let firstLevelSecondMenu = firstLevel.querySelector(".second-level-menu");
              if (firstLevelSecondMenu) {
                  firstLevelSecondMenu.style.display = "block";
  
                  // Show all third and fourth-level menus under this second-level menu
                  // firstLevelSecondMenu.querySelectorAll(".third-level-menu").forEach(thirdMenu => {
                  //     thirdMenu.style.display = "block";
                  //     thirdMenu.querySelectorAll(".fourth-level-menu").forEach(fourthMenu => {
                  //         fourthMenu.style.display = "block";
                  //     });
                  // });
              }
          }
      }
  });
  /* ==== End By Category Filter ==== */

  
});


/* ==== Merchandising Studio ==== */

document.addEventListener('algolia.hooks.initialize', function() {
  algoliaShopify.hooks.registerHook('beforeInstantSearchFiltersString', 
    function(defaultFilter) {
      if (defaultFilter && defaultFilter.includes("collection_ids")) {
        const collectionIDFilterRegex = /collection_ids:"\w+"/g;
        const matches = window.location.pathname.match(
          /\/collections\/([^/]+)/i
        );
        const collectionHandle = (matches && matches.length === 2) 
          ? matches[1] : null;
        if (collectionHandle) {
          return defaultFilter.replace(
            collectionIDFilterRegex, "collections:" + collectionHandle
          );
        }
      }
      return defaultFilter;
    }
  );
});


